import $ from "cash-dom";
import smoothScroll from "smoothscroll";
import ClipboardJS from "clipboard";
import Cookie from "js-cookie";
import "./merchant-redirection";
import merchantFollowInit from "./merchant-follow";
import gaSC, { npga, npga2 } from "@common/utils/ga";
import registerScrollListener from "@common/utils/scroll-listener";
import { getCidObject } from "@common/tracking/cid-tracking";
import attachShowMoreHandler from "@common/utils/show-more";
import { request, apiBase } from "@common/request";
import {
  shareEmail,
  shareTwitter,
  shareWhatsApp,
  shareFacebook,
  shareLinkedIn,
  shareInstagram,
} from "@common/utils/sharers";
import {
  openLoginModal,
  isLoggedIn,
  currentUserName,
} from "@common/headers/login";
import { grabOnInit } from "@core";
import { ShowAlert } from "@common/utils/alert";
import { assetUrl } from "@common/utils/asset-url";
import smoothscroll from "smoothscroll";
import isMobile from "@common/utils/is-mobile";
import setTimeoutAsync from "@common/utils/set-timeout";
import showMoreDesc from "@common/utils/show-more-v2";
import BubbleHoverEffect from "@common/utils/bubble-hover-efffect";
import { checkIfInViewport } from "@common/events/checkIfInView";
import initCouponPagination, {
  applyServerFilters,
  syncTabCounts,
} from "./coupon-pagination";
import initVerificationFeed from "./verification-feed";

var whenFilterActiveHideSelectors = $(
  ' div[data-type="coupon-box-parent"] h2.gmc-title:not([data-filter-visible="show"]), div[data-list-type="suggested"], div[data-list-type="suggested"]',
);
const mainContentEle = document.querySelector(
  'section.main-section div[data-type="content-ele"]',
);
const allTagMainEles = mainContentEle.querySelectorAll(
  'div[data-type="tags-main-div"]',
);
const stateAtr = "data-state";
const divTypeAtr = "data-div-type";
const NotRequiredClick = ["recommended-stores", "selected-filters"];
const filteredTagMainEles = Array.from(allTagMainEles).filter((ele) => {
  const condition1 = !NotRequiredClick.includes(ele.getAttribute(divTypeAtr));
  return condition1;
});

$(() => {
  grabOnInit();
  loadSvgs();
  registerScrollListener();
  filterCheckBoxes(); // filter listener
  filterCouponClassfication(); // top bar filter listener
  // ExistingUser(); // existing user filter listener
  showDescriptionComments(); // show details/commments/desc
  // AllCategoriesSearch(); // filter search listener
  // starRating(); // Ratings listener
  // filterExpansion();
  tagFilter();
  closeFilterTabs();
  clearAll();
  OpenCouponBox();
  // MerchantLinkClick(); // For merchant links in open coupon boxes
  // commentMethods();
  filterClick();
  openDescription();
  gaTracking();
  share();
  // couponSave();
  // ExtensionHandlers();
  // handleRatings();
  // fixNav();
  ShowUfsData();
  merchantFollowInit();
  initVerificationFeed();
  // addCommentBoxToTheCoupon();
  linkAppendForFirstCoupon();
  ExistingUserV2();
  refreshRatingModule();
  showMoreDesc();
  initPopularStoresToggle();
  FilterManagementV2();
  sortByFunctions();
  getShareListDOMV2();
  couponBoxFunctionalityV2();
  ExtensionBoxFunV2();
  checkIfInViewport();
  // "Show more coupons". The callback re-applies the visitor's current tab and
  // sidebar selections to the batch that just arrived — appended cards come
  // back unfiltered, and both functions re-derive from scratch over every
  // .gc-box, so running them again is enough.
  initCouponPagination(function () {
    // Only the tab. The batch was fetched WITH the active filters, so it is
    // already narrowed — running showFilteredCoupons() over it would re-filter
    // server-filtered cards against an index built from the first 80.
    const activeTab = $("#gmTab > li.go-gmt-link.active").data("type");
    _filterCouponClassifications(activeTab || "all");
    if (window.lazyLoad) window.lazyLoad.update();
  });
  // goGlobal.sharedData.onCouponClick = (ele, callback) => {
  //     const temp = $('<span></span>');
  //     const cpb = new ClipboardJS(temp.get(0), {
  //         text: e => $(ele).parent().find('.gcbr > .gcbr-r > .cbtn > span.visible-lg:not(.cp)').text()
  //     })
  //         .on('success', () => {
  //             callback();
  //             cpb.destroy();
  //             temp.remove();
  //         });
  //     $(temp).trigger('click');
  // };

  $("#gmfDesp").on("click", function () {
    if ($(this).hasClass("show")) {
      gaSC("Merchant Description", "hide");
      smoothscroll(
        $(".gmf-des").offset().top -
          ($("header").outerHeight() +
            $(
              "#gmTab.fixed, #gmTabMobile.fixed, .mobile-tabs-row.fixed",
            ).outerHeight()),
        1000,
      );
    } else {
      gaSC("Merchant Description", "show");
    }
    $(this).toggleClass("show");
  });
  attachShowMoreHandler(
    $(".gmc-det .mReadMore"),
    (ele) => $(ele).parent('div[data-type="ext-content-ele"]'),
    "Read More",
    "Read Less",
    "show",
  );

  setTimeout(function () {
    const params = new URL(location.href).searchParams;
    const goloc = params.get("goloc") || "";

    filteredTagMainEles.forEach((filterDiv, filterIndex) => {
      const isTagsDiv = filterDiv.getAttribute(divTypeAtr) === "sort-by-tags";
      if (isTagsDiv) {
        const allTags = filterDiv.querySelectorAll("div > button");
        const dataTypeAttr = "data-type";
        const hasButton = Array.from(allTags).filter(
          (ele) =>
            ele.getAttribute(dataTypeAttr).trim().toLowerCase() ===
            goloc.replace(/[+]/g, " ").trim().toLowerCase(),
        );
        if (hasButton.length > 0) {
          Array.from(allTags).forEach((ele, eleIndex) => {
            ele.setAttribute(stateAtr, "inactive");
          });
          hasButton[0].setAttribute(stateAtr, "active");
          filterCoupon(
            hasButton[0].getAttribute(dataTypeAttr).trim(),
            "tags",
            false,
          );
        }
      }
    });

    // const goloc$ = $('#tagFilter li').filter((i, data) => $(data).text().trim().toLowerCase() == goloc.replace(/[+]/g, ' ').trim().toLowerCase()); //.trigger('click');
    // if (goloc$.length) {
    //     $('#tagFilter li').removeClass('active');
    //     goloc$.addClass('active');

    //     filterCoupon(goloc$.text().trim(), 'tags', false);
    // }
  }, 100);
  $(".gcbr > a, .grsug a, .grsug2 a").on("click", (event) => {
    // Coupon box listener is taking over and not opening this link.
    event.stopPropagation();
  });
});

function gaTracking() {
  // npga(".go-heartIco", "Heart Icon");
  npga(".go-cstm-bnr", "Category Top Banner");
  npga(".go-cstm-bnr-1", "Category Middle Banner One");
  npga(".go-cstm-bnr-2", "Category Middle Banner Two");
  npga(".go-cstm-bnr-3", "Category Middle Banner Three");
  npga(".go-cstm-bnr-small", "Category Side Banner Small");
  npga(".go-cstm-bnr-large", "Category Side Banner Large");
  $('div[data-type="custom-image-link"] > a').on("click", function () {
    gaSC("Sidebar - Preferences Banner Click", "Sidebar");
  });
  npga(
    ".g-bread > li, .go-breadCrumbs > li, .gbc-breadCrumbs > li, .breadcrumbs > li, .breadcrumb-section ul > li",
    "Bread Crumb Click",
  );
  npga('.gm-mri, div[data-type="img-ele"]', "Coupon List Page Logo Clicked");
  // Support both legacy coupon card markup (.gcbr) and new footer-links markup.
  npga2(
    '.gcbr > a, [data-div-type="footer-links"] > a, .footer-links > a',
    "View All Store Coupons",
  );
  $(
    '.gmc-rec > ul > li, div[data-type="related-items-row"] > div, div[data-div-type="recommended-stores"] > div > a',
  ).on("click", function () {
    gaSC("Recommended Stores", $(this).text().trim());
  });
  $(
    '.gmc-det > article a, div[data-type="gmc-det-v2"] div[data-type="ext-content-ele"] a',
  ).on("click", function () {
    gaSC("Extension Links", $(this).attr("href"));
  });
  $('.gmf-rel-store a, div[data-type="related-items-row"] > div a.title').on(
    "click",
    function () {
      const $t = $(this);
      var h4 = $t.siblings("p");
      var source =
        (h4 && h4.text && h4.text().trim()) ||
        $t.closest("div").find("p.title").first().text().trim() ||
        "Related Stores";
      gaSC(source, $t.text());
    },
  );
  npga("div[data-type=popular-stores]>div>div", "Sidebar Popular Stores");
  npga('.blog-col, [data-type="blog-col"]', "Blog Redirection");
}
function filterClick() {
  const datasidebar = $('section.main-section div[data-type="sidebar"]');
  const mobileFilterIcon = $(".mobile-filter-icon-v2");
  const mobileSidebarCloseBtn = $(".mobile-sidebar-close-btn");
  const cls = "show-mobile";

  function setSidebarState(isOpen) {
    mobileFilterIcon.attr("data-state", isOpen ? "active" : "inactive");
    datasidebar.toggleClass(cls, isOpen);
    $(".mobile-tabs-row").toggleClass("fixed", false);
    if (isOpen) {
      $("body").addClass("f-open");
      checkIfInViewport(true);
    } else {
      $("body").removeClass("f-open");
    }
  }

  mobileFilterIcon.on("click", function () {
    const isOpen = datasidebar.hasClass(cls);
    if (!isOpen) {
      gaSC("Mobile Filter Icon");
    }
    setSidebarState(!isOpen);
  });

  mobileSidebarCloseBtn.on("click", function () {
    setSidebarState(false);
  });
}

function openDescription() {
  $(document).on("keypress", function (e) {
    if (e.ctrlKey && e.code == "KeyM")
      // $('.c-show-det').trigger('click');
      $(
        'div[data-type="right-left"] > button, div[data-type="right-left"] > div[data-type="meta-row"] > button',
      ).trigger("click");
  });
}
function addCommentBoxToTheCoupon() {
  var cpnBoxes = $(".gc-box");
  var personName = currentUserName();
  $.each(cpnBoxes, async function (i, box) {
    var thisBox = $(box);
    const couponid = $(box).data("cid");
    // let data = await request.get(goGlobal.WEB_URL + 'misc/getallreviews/' + couponid);
    // data = data.trim();
    var commentBox = thisBox.find(".gcb-com");
    var placeholder = !personName
      ? "Comment here..."
      : "Commenting as " + personName + "...";
    var comments = commentBox.find(".go-cmnt").length;
    var commentBoxText = `
            <div class="go-replyBox pure-form">
                <textarea class="go-textA" placeholder="${placeholder}"></textarea>
                <button type="button" class="pure-button sendRep">Submit</button>
            </div>
        `;
    if (comments && comments >= 3) {
      commentBoxText += '<span class="allCmnts">View more comments</span>';
    }
    commentBox.append(commentBoxText);
  });
}

function commentMethods() {
  $("#gBody").on("click", ".allCmnts", async function (event) {
    event.stopPropagation();
    const $t = $(this);
    const couponid = $t.parents(".gc-box").data("cid");
    if (couponid) {
      const data = await request.get(
        goGlobal.WEB_URL + "misc/getallreviews/" + couponid,
      );
      $t.siblings("ul").remove();
      $t.siblings("span.cl-com").after(data);
      //$t.remove();
      $t.addClass("hidden");
    }
  });

  //#region Reply to comment

  $("#gBody").on("click", ".reply", function () {
    var t = $(this);
    var personName = currentUserName();
    var parent = t.closest("li");
    if (!parent.next().hasClass("go-replyBox")) {
      var placeholder = !personName
        ? "Comment here..."
        : "Commenting as " + personName + "...";
      var commentBox = `
                <div class="go-replyBox between pure-form go-replyContainer">
                    <textarea class="go-textA" placeholder="${placeholder}"></textarea>
                    <button class="pure-button sendRep2">Submit</button>
                </div>
            `;
      parent
        .closest("ul")
        .find(".go-replyBox")
        .each((i, box) => {
          if (!$(box).find(".go-textA").val()) $(box).remove();
        });
      parent.after(commentBox);
    }
  });

  $("#gBody").on(
    "click",
    ".go-replyContainer .sendRep2",
    async function (event) {
      event.stopPropagation();

      if (!isLoggedIn()) {
        openLoginModal();
        return;
      }

      const $t = $(this);
      const $input = $t.siblings("textarea");
      const $li = $t.parent().prev();
      const val = $input.val();
      const userid = $li.attr("data-userid");
      const couponid = $t.closest(".gc-box").data("cid");
      if (val && userid) {
        var json = { text: val, replyid: userid, couponid: couponid };
        await request.post(
          goGlobal.WEB_URL + "misc/savereply",
          { data: json },
          { json: true },
        );
        $t.parent().remove();
        ShowAlert("Your Comment Has Been Submitted For Moderation");
      }
    },
  );

  //#endregion

  $("body").on("click", ".gcb-com .sendRep", async function (event) {
    event.stopPropagation();
    if (!isLoggedIn()) {
      openLoginModal();
      return;
    }
    const $t = $(this);
    const couponid = $t.parents(".gc-box").data("cid");
    const $input = $t.siblings("textarea");
    const val = $input.val();
    if (val) {
      var json = { text: val, couponid: couponid };
      await request.post(
        goGlobal.WEB_URL + "misc/savereply",
        { data: json },
        { json: true },
      );
      ShowAlert("Your Comment Has Been Submitted For Moderation");
      $input.val("");
    }
  });
}

function starRating() {
  $("#gmRating").on("click", () => $("#gBody").addClass("open-rating-modal"));
  $("#closeRatingModal").on("click", () =>
    $("#gBody").removeClass("open-rating-modal"),
  );
}
function filterExpansion() {
  $(".go-s-acc > p, .go-s-acc > span").on("click", function () {
    $(this).parent().find("span").toggleClass("show");
  });
}
function showDescriptionComments() {
  // $('.c-show-det').text('Show Details');
  $(".c-show-det").on("click", function (event) {
    event.stopPropagation();

    const t = $(this);
    const coupBox = t.parents(".gc-box");
    let descState = t.data("state");

    if (!descState || descState == "hide") {
      coupBox.find(".gcb-det").addClass("open");
      // t.text('Hide Details');
      // t.attr('data-after', 'Hide Details');
      t.addClass("c-hide-det");
      descState = "show";
    } else {
      coupBox.find(".gcb-det").removeClass("open");
      // t.text('Show Details');
      // t.attr('data-after', 'Show Details');
      t.removeClass("c-hide-det");
      descState = "hide";
    }

    t.data("state", descState);
    coupBox.find(".gcb-com").removeClass("open");
    coupBox.find(".c-show-cou").data("state", "hide");
    gaSC("Show Details", descState);
    if (descState === "show" && isMobile()) {
      coupBox.find(".go-cpn-show").trigger("click");
    }
  });

  $(".c-show-cou").on("click", async function (event) {
    event.stopPropagation();

    var t = $(this);
    const coupBox = t.parents(".gc-box");
    let commState = t.data("state");

    const t1 = coupBox.children(".gcb-com").children("span.allCmnts");
    const couponid = t1.parents(".gc-box").data("cid");
    if (couponid && commState === "hide") {
      let data = await request.get(
        goGlobal.WEB_URL + "misc/getallreviews/" + couponid,
      );
      if (data != null) {
        data = data.trim();
        var childs = $(data).children("li");
        if (childs.length > 0) {
          childs = childs.slice(0, 3);
          t1.siblings("ul").remove();
          let li = "";
          childs.each(function () {
            li +=
              "<li" +
              ' data-userid="' +
              $(this).data("userid") +
              '">' +
              $(this).html() +
              "</li>";
          });
          const ul = '<ul class="list-unstyled">' + li + "</ul>";
          t1.siblings("span.cl-com").after(ul);
        }
      }
    }

    t1.removeClass("hidden");

    if (!commState || commState == "hide") {
      t.parents(".gc-box").find(".gcb-com").addClass("open");
      commState = "show";
    } else {
      t.parents(".gc-box").find(".gcb-com").removeClass("open");
      commState = "hide";
    }

    t.data("state", commState);
    coupBox.find(".gcb-det").removeClass("open");
    // coupBox.find('.c-show-det').text('Show Details').data('state', 'hide');;
    coupBox.removeClass("c-hide-det");
    coupBox.find(".c-show-det").data("state", "hide");
    gaSC("Show Comments", commState);
  });

  $(".cl-det").on("click", function (event) {
    event.stopPropagation();

    var t = $(this);
    t.parents(".gcb-det").removeClass("open");

    var descriptionToggle = t.parents(".gc-box").find(".c-show-det");
    // descriptionToggle.text('Show Details').data('state', 'hide');
    descriptionToggle.removeClass("c-hide-det");
    descriptionToggle.data("state", "hide");
  });

  $(".cl-com").on("click", function (event) {
    event.stopPropagation();

    var t = $(this);
    t.parents(".gcb-com").removeClass("open");
    var descriptionToggle = t.parents(".gc-box").find(".c-show-cou");
    descriptionToggle.data("state", "hide");
  });
}
function AllCategoriesSearch() {
  $("#mSearch").on("keyup", function (event) {
    triggerSearch(event.key === "Escape");
  });
  $("#mSearch").on("focus", function () {
    gaSC("Search in Filters Clicked");
  });
}
/**
 * @param {boolean} [clear]
 */
function triggerSearch(clear) {
  const input$ = $("#mSearch");
  if (clear) {
    input$.val("");
  }
  const searchText = input$.val().toString().toLowerCase();

  $(".go-s-acc > span").removeClass("show"); // does the opposite of show
  input$
    .parents(".gmcf-w")
    .find(".go-s-acc label")
    .each(function () {
      var label$ = $(this),
        dataStr = label$.text().trim().toLowerCase();
      if (dataStr.indexOf(searchText) !== -1) {
        label$.parents("li").removeClass("hidden");
      } else {
        label$.parents("li").addClass("hidden");
      }
    });

  if (!searchText) return;
  var visBank = $("#bnkFilters > li.hidden");
  var visCat = $("#catFilters > li.hidden");
  var visStores = $("#storeFilters > li.hidden");
  if (visBank.length === 0) {
    $("#bnkFilter").addClass("show");
  }
  if (visCat.length === 0) {
    $("#catFilter").addClass("show");
  }
  if (visStores.length === 0) {
    $("#storeFilter").addClass("show");
  }
}
function filterCheckBoxes() {
  $(".gmcf-w > .go-s-acc li > input").on("change", function () {
    var $t = $(this);
    var filterValue = $t.val().toString().trim();
    filterValue = $("<textarea/>").html(filterValue).text();
    var isC = $t.is(":checked");

    _filterCheckBoxes(isC, filterValue);
    // The V1 sidebar. Not this page's DOM (FilterManagementV2 owns the
    // checkboxes we render), but pointed at the same re-fetch so there is one
    // behaviour whichever variant is present.
    reloadCouponsForFilters();
    // smoothScroll(0, 600);
    var par = $t.parents(".go-s-acc");
    if (par) {
      var sp = $(par).children("p");
      if (sp) {
        if (isC) {
          gaSC(sp.text() + " - Checked", filterValue);
        } else {
          gaSC(sp.text() + " - UnChecked", filterValue);
        }
      }
    }
  });
}
/**
 * @param {boolean} isChecked
 * @param {string} filterValue
 */
function _filterCheckBoxes(isChecked, filterValue) {
  const couponBox = $(".gc-box");
  couponBox.addClass("go-fl-hidden");
  var selectedFiltersSection = $(".gmc-fil-val > ul");
  var currentLis = selectedFiltersSection.children("li").length;
  if (isChecked) {
    if (currentLis == 0) {
      selectedFiltersSection.html(
        '<li class="clearFilter">Clear All<span><svg width="18px" height="17px" viewBox="0 0 18 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Design-2-Copy-4" transform="translate(-1085.000000, -224.000000)" fill="#010002" fill-rule="nonzero" stroke="#000000" stroke-width="0.2"><g id="cross-out" transform="translate(1086.000000, 225.000000)"><polygon id="Path" points="16 0.498645952 15.5021158 0 8 7.50128278 0.498383088 0 0 0.498645952 7.50161691 7.99985747 0 15.5011403 0.498383088 16 8 8.4977195 15.5021158 16 16 15.5011403 8.49838309 7.99985747"></polygon></g></g></g></svg></span></li>',
      );
    }
    whenFilterActiveHideSelectors.addClass("go-fl-hidden");
    selectedFiltersSection.find('li[data-fs="' + filterValue + '"]').remove();
    selectedFiltersSection.prepend(
      `<li class="go-closefilter" data-type="f" data-fs="${filterValue}">${filterValue}<span><svg width="18px" height="17px" viewBox="0 0 18 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Design-2-Copy-4" transform="translate(-1085.000000, -224.000000)" fill="#010002" fill-rule="nonzero" stroke="#000000" stroke-width="0.2"><g id="cross-out" transform="translate(1086.000000, 225.000000)"><polygon id="Path" points="16 0.498645952 15.5021158 0 8 7.50128278 0.498383088 0 0 0.498645952 7.50161691 7.99985747 0 15.5011403 0.498383088 16 8 8.4977195 15.5021158 16 16 15.5011403 8.49838309 7.99985747"></polygon></g></g></g></svg></span></li>`,
    );
  } else {
    selectedFiltersSection.find('li[data-fs="' + filterValue + '"]').remove();
    currentLis = selectedFiltersSection.children("li").length;
    if (currentLis == 1) {
      // $('.mFilters').removeClass('filterApplied');
      whenFilterActiveHideSelectors.removeClass("go-fl-hidden");
      selectedFiltersSection.html("");
    }
  }
}

function showFilteredCoupons() {
  var s = $(
    'div[data-type="filter-children-div"][data-content="stores"] > ul > li input[type="checkbox"]:checked',
  );
  var c = $(
    'div[data-type="filter-children-div"][data-content="categories"] > ul > li input[type="checkbox"]:checked',
  );
  var b = $(
    'div[data-type="filter-children-div"][data-content="banks"] > ul > li input[type="checkbox"]:checked',
  );
  var catFilters = [];
  var bankFilters = [];
  var storeFilters = [];
  if (c.length > 0) {
    c.each(function (index, ele) {
      catFilters.push($(ele).attr("value").toString());
    });
  }
  if (b.length > 0) {
    b.each(function (index, ele) {
      bankFilters.push($(ele).attr("value").toString());
    });
  }
  if (s.length > 0) {
    s.each(function (index, ele) {
      storeFilters.push($(ele).attr("value").toString());
    });
  }
  var hascats = catFilters.length > 0;
  var hasBanks = bankFilters.length > 0;
  var hasStores = storeFilters.length > 0;
  var cpnBoxes = $(".gc-box");
  var gBoxparent = $('div[data-type="coupon-box-parent"] > .gmc-list');
  if (hascats || hasBanks || hasStores) {
    var validCouponIDs = [];
    if (hascats) {
      for (var i = 0; i < window.couponCategoryFilters.length; i++) {
        var currentCF = window.couponCategoryFilters[i];
        if (currentCF) {
          if (catFilters.indexOf(currentCF.Filter) !== -1) {
            var currentCids = currentCF.CouponIDs;
            for (var j = 0; j < currentCids.length; j++) {
              if (validCouponIDs.indexOf(currentCids[j]) === -1) {
                validCouponIDs.push(currentCids[j]);
              }
            }
          }
        }
      }
    }
    if (hasStores) {
      for (var i = 0; i < window.couponMerchantFilters.length; i++) {
        var currentCF = window.couponMerchantFilters[i];
        if (currentCF) {
          if (storeFilters.indexOf(currentCF.Filter) !== -1) {
            var currentCids = currentCF.CouponIDs;
            for (var j = 0; j < currentCids.length; j++) {
              if (validCouponIDs.indexOf(currentCids[j]) === -1) {
                validCouponIDs.push(currentCids[j]);
              }
            }
          }
        }
      }
    }
    if (hasBanks) {
      for (var i = 0; i < window.couponBankFilters.length; i++) {
        var currentCF = window.couponBankFilters[i];
        if (currentCF) {
          if (bankFilters.indexOf(currentCF.Filter) !== -1) {
            var currentCids = currentCF.CouponIDs;
            for (var j = 0; j < currentCids.length; j++) {
              if (validCouponIDs.indexOf(currentCids[j]) === -1) {
                validCouponIDs.push(currentCids[j]);
              }
            }
          }
        }
      }
    }

    for (var i = 0; i < validCouponIDs.length; i++) {
      var cBox = $("#cpn_" + validCouponIDs[i]);
      cBox.removeClass("go-fl-hidden");
      addOrRemoveAnim(cBox);
      // if(!cBox.hasClass('g-animated')){
      //     cBox.addClass('g-animated');
      // }
    }
    gBoxparent.each((i, item) => {
      const gItem = $(item);
      const allBoxs = gItem.find(".gc-box:not(.go-fl-hidden)");
      if (
        // STRING compare, not Number(). .in's coupon ids are integers; ours are
        // the gateway's short show-codes ("mfftsk"), so Number() is NaN for
        // every card and this test would hide every list on the page.
        !Array.from(allBoxs).some((ele) =>
          validCouponIDs.includes(String(ele.getAttribute("data-cid"))),
        )
      ) {
        gItem.addClass("go-fl-hidden");
      } else {
        gItem.removeClass("go-fl-hidden");
      }
    });
  } else {
    cpnBoxes.removeClass("go-fl-hidden");
    addOrRemoveAnim(cpnBoxes);
    // if(!cpnBoxes.hasClass('g-animated')){
    //     cpnBoxes.addClass('g-animated');
    // }
    gBoxparent.removeClass("go-fl-hidden");
  }
  window.lazyLoad.update();

  toggleExpiredCouponsHeading();
  _updateGmTabCounts();
}
function closeFilterTabs() {
  $("#gBody").on("click", ".go-closefilter", function () {
    var t = $(this);
    var fValue = t.data("fs");

    var checkBox = $(".go-s-acc ul input").filter((i, ele) => {
      // https://medium.com/@tertiumnon/js-how-to-decode-html-entities-8ea807a140e5
      const val = $("<textarea/>").html($(ele).val().toString()).text();
      return val == fValue;
    });
    checkBox.prop("checked", false);
    t.remove();
    if ($(".gmc-fil-val > ul > li").length == 1) {
      // $('.mFilters').removeClass('filterApplied');
      $(".gmc-fil-val > ul").html("");
      $("h2.gmc-title, .grsug, .grsug2").removeClass("go-fl-hidden");
    }
    // The V1 chip. Its selectors (.go-s-acc, .gmc-fil-val) are not in this
    // page's DOM — the V2 chips in [data-div-type="selected-filters"] are what
    // renders — but it is pointed at the same re-fetch so whichever variant
    // fires behaves identically.
    reloadCouponsForFilters();
  });
}
function filterCouponClassfication() {
  $("#gmTab > li.go-gmt-link, #gmTabMobile > li.go-gmt-link").on(
    "click",
    function () {
      var this$ = $(this);
      $("#gmTab > li.go-gmt-link, #gmTabMobile > li.go-gmt-link").removeClass(
        "active",
      );
      this$.addClass("active");
      var filterType = this$.data("type");

      _filterCouponClassifications(filterType);
    },
  );
}
function _filterCouponClassifications(filterType) {
  var couponsParent = $(".gmc-list");
  var allCoupons = couponsParent.find(".gc-box");
  const $cls = "go-tab-hidden";
  var coupons = couponsParent.find('.gc-box[data-type="cp"]');
  var deals = couponsParent.find('.gc-box[data-type="dl"]');

  var freshCpns = couponsParent.find('.gc-box[data-isfresh-cpn="True"]');
  allCoupons.removeClass("hidden");
  switch (filterType) {
    case "all":
      // allCoupons.sort(function (a, b) {
      //     var sortA = parseInt($(a).children('.gc-box').data('cpnpstn'));
      //     var sortB = parseInt($(b).children('.gc-box').data('cpnpstn'));
      //     return (sortA < sortB) ? -1 : (sortA > sortB) ? 1 : 0;
      // });
      // $('h2.gmc-title').each(function (index, elm) {
      //     var el = $(elm);
      //     var cl = el.clone();
      //     el.remove();
      //     var d = $('.go-coupBox[data-cpnpstn="' + el.attr('data-pos') + '"]');
      //     if (!nullOrEmpty(d)) {
      //         d.before(el);
      //         el.show();
      //     }
      // })
      // couponsParent.children().remove();
      // allCoupons.detach().appendTo(couponsParent.first());
      allCoupons.removeClass($cls);
      whenFilterActiveHideSelectors.removeClass($cls);
      addOrRemoveAnim(allCoupons);
      gaSC("Top Tabs: All");
      break;
    case "cpn":
      allCoupons.addClass($cls);
      whenFilterActiveHideSelectors.addClass($cls);
      coupons.removeClass($cls);
      addOrRemoveAnim(coupons);
      gaSC("Top Tabs: Coupons");
      break;
    case "dl":
      allCoupons.addClass($cls);
      whenFilterActiveHideSelectors.addClass($cls);
      deals.removeClass($cls);
      addOrRemoveAnim(deals);
      gaSC("Top Tabs: Offers");
      break;
    case "fresh":
      allCoupons.addClass($cls);
      whenFilterActiveHideSelectors.addClass($cls);
      freshCpns.slice(0, 9).removeClass($cls);
      addOrRemoveAnim(freshCpns);
      break;
    // case "mu":
    //     allCoupons.sort(function (a, b) {
    //         var sortA = parseInt($(a).children('.gc-box').data('couponvisits'));
    //         var sortB = parseInt($(b).children('.gc-box').data('couponvisits'));
    //         return (sortA > sortB) ? -1 : (sortA < sortB) ? 1 : 0;
    //     });
    //     couponsParent.children().remove();
    //     allCoupons.detach().appendTo(couponsParent.first());
    //     break;
  }
  AddOrRemoveFilterClsForParent($cls, filterType, filterType !== "all");
  //   smoothScroll(0, 600);
  toggleExpiredCouponsHeading();
  _updateGmTabCounts();
}

function ExistingUser() {
  $("#existingUser, #existingUser2").on("change", function () {
    var t = $(this);
    if (t.prop("checked") === true) {
      $(".gc-box").addClass("go-ex-hidden");
      $('.gc-box[data-eid="1"]').removeClass("go-ex-hidden");
      gaSC("Existing User", "Checked");
      $("h2.gmc-title, .grsug, .grsug2").addClass("go-ex-hidden");
    } else {
      $(".gc-box").removeClass("go-ex-hidden");
      gaSC("Existing User", "Un-Checked");
      $("h2.gmc-title, .grsug, .grsug2").removeClass("go-ex-hidden");
    }
  });
}

function syncUserTypeControls(isExistingUserActive) {
  const active = !!isExistingUserActive;
  const existingUserControls = $(".existing-user-div > button, #existingUser2");
  const allUsersControl = $("#allUsers2");

  existingUserControls.attr("data-state", active ? "active" : "inactive");
  allUsersControl.attr("data-state", active ? "inactive" : "active");
}

/**
 * Re-fetch the coupon list for whatever is currently selected.
 *
 * The single entry point for every control that narrows the list: sidebar
 * checkboxes, the Existing User toggle, tag chips. It reads the selections back
 * off the DOM, so the ported .in handlers keep owning their own controls and
 * this only has to run after them.
 */
function reloadCouponsForFilters() {
  return applyServerFilters(function () {
    // The replaced cards are already the filtered set, so the client-side
    // passes must NOT run over them — go-fl-hidden / go-ex-hidden would hide
    // rows the server just said match. Only the expired heading still needs
    // re-evaluating, since that list is untouched by the fetch.
    toggleExpiredCouponsHeading();
    if (window.lazyLoad) window.lazyLoad.update();
  });
}

function applyExistingUserFilter(isExistingUserActive, trackingLabel) {
  const active = !!isExistingUserActive;

  syncUserTypeControls(active);

  // `existingUser` is a query parameter on the categories endpoint — the whole
  // reason the sidebar comment says this toggle re-fetches rather than
  // filtering in place. Verified: it takes /electronics-coupons/ from 1,973
  // coupons to 766, a set the loaded 80 cannot represent.
  gaSC(trackingLabel || "Existing User", active ? "Checked" : "Un-Checked");
  reloadCouponsForFilters();
  //   smoothScroll(0, 600);
}

/** The pre-server-fetch behaviour, kept for reference. No longer called. */
function _applyExistingUserFilterClientSide(
  isExistingUserActive,
  trackingLabel,
) {
  const active = !!isExistingUserActive;
  const gBoxparent = $('div[data-type="coupon-box-parent"] > .gmc-list');

  syncUserTypeControls(active);

  if (active) {
    $(".gc-box").addClass("go-ex-hidden");
    $('.gc-box[data-eid="1"]').removeClass("go-ex-hidden");
    addOrRemoveAnim($('.gc-box[data-eid="1"]'));
    whenFilterActiveHideSelectors.addClass("go-ex-hidden");
    gBoxparent.each((i, item) => {
      const gItem = $(item);
      const allBoxs = gItem.find(".gc-box:not(.go-fl-hidden)");
      const allExistingUsers = $('.gc-box[data-eid="1"]');
      if (
        !Array.from(allBoxs).some((ele) =>
          Array.from(allExistingUsers).includes(ele),
        )
      ) {
        gItem.addClass("go-ex-hidden");
      } else {
        gItem.removeClass("go-ex-hidden");
      }
    });
    gaSC(trackingLabel || "Existing User", "Checked");
    toggleExpiredCouponsHeading();
    _updateGmTabCounts();
  } else {
    $(".gc-box").removeClass("go-ex-hidden");
    whenFilterActiveHideSelectors.removeClass("go-ex-hidden");
    gBoxparent.removeClass("go-ex-hidden");
    gaSC(trackingLabel || "Existing User", "Un-Checked");
    toggleExpiredCouponsHeading();
    _updateGmTabCounts();
  }

  //   smoothScroll(0, 600);
}
function tagFilter() {
  $("#tagFilter > li, #locFilter > li").on("click", function () {
    var this$ = $(this);
    if (!this$.hasClass("active")) {
      this$.siblings().removeClass("active");
      this$.addClass("active");
      var isAll = this$.hasClass("all");
      filterCoupon(this$.text().trim(), "tags", isAll);

      if (this$.parents("#tagFilter").length == 0) return;
      gaSC("Sort By Tags", this$.text().trim());
    }
  });
}
/**
 * @param {string} textValue
 * @param {string} dataAttribute
 * @param {boolean} isAll
 */
function filterCoupon(textValue, dataAttribute, isAll) {
  var couponBoxes = $(".gc-box");
  const $cls = "go-st-hidden";
  // var gBoxparent = $('div[data-type="coupon-box-parent"] > .gmc-list');
  if (isAll) {
    couponBoxes.each((i, box) => $(box).removeClass($cls));
    whenFilterActiveHideSelectors.removeClass($cls);
    AddOrRemoveFilterClsForParent(
      $cls,
      "tags",
      !isAll,
      textValue,
      dataAttribute,
    );
    toggleExpiredCouponsHeading();
    _updateGmTabCounts();
    return;
  }

  couponBoxes.each((i, box) => {
    var tags = $(box).data(dataAttribute);
    if (tags) {
      var tagArr = tags.split(",");
      if (tagArr != null && tagArr.length > 0) {
        tagArr = tagArr.map(function (s) {
          return s.trim();
        });
      }
      if (Array.isArray(tagArr)) {
        if (tagArr.indexOf(textValue) === -1) {
          $(box).addClass($cls);
        } else {
          $(box).removeClass($cls);
          addOrRemoveAnim($(box));
        }
      }
    } else {
      $(box).addClass($cls);
    }
  });
  whenFilterActiveHideSelectors.addClass($cls);
  AddOrRemoveFilterClsForParent($cls, "tags", !isAll, textValue, dataAttribute);
  toggleExpiredCouponsHeading();
  _updateGmTabCounts();
}

function toggleExpiredCouponsHeading() {
  const expiredCouponLists = $(
    'div[data-type="coupon-box-parent"] .gmc-list[data-type="expired-coupons"]',
  );
  if (!expiredCouponLists || expiredCouponLists.length === 0) return;

  expiredCouponLists.each((i, listEle) => {
    const listItem = $(listEle);
    const headingItem = listItem.prev(
      'p[data-heading="heading2-v2"].gmc-title',
    );
    if (!headingItem || headingItem.length === 0) return;

    // Check if any expired coupons are visible across ALL active filters
    const hasVisibleExpiredCoupons =
      listItem.find(
        ".gc-box:not(.go-ex-hidden):not(.go-fl-hidden):not(.go-st-hidden):not(.go-tab-hidden)",
      ).length > 0;

    // Use go-st-hidden as the unified class to hide/show the heading
    headingItem.toggleClass("go-st-hidden", !hasVisibleExpiredCoupons);
  });
}

/**
 * Repaint the tab counts.
 *
 * .in counts the `.gc-box` nodes on the page here. THAT CANNOT WORK ON THIS
 * PAGE. .in renders every coupon, so its node count is the total; we render 80
 * of up to ~3,300, so counting nodes reports the window. Every call site — and
 * a tab click is one of them — turned "All (3,286)" into "All (80)".
 *
 * The counts now live on [data-type="coupon-box-parent"] as data-count-*,
 * written by the generator and rewritten only when a filter fetch changes the
 * result set. Reading them keeps every existing call site correct without
 * having to find them all.
 */
function _updateGmTabCounts() {
  syncTabCounts();
}

function clearAll() {
  $("#gBody").on(
    "click",
    '.clearFilter, #filterClear, .gmcf-w > span, .clear-all-filters, [data-action="clear-filters"]',
    function () {
      // Both DOM variants: the V1 inputs above, and the ones this page
      // actually renders. .prop() does not fire change, so the re-fetch below
      // is what resets the list.
      $(".gmcf-w > .go-s-acc li > input").prop("checked", false);
      $('div[data-type="filter-children-div"] ul li input[type="checkbox"]')
        .prop("checked", false)
        .parent()
        .attr("data-checked", "false");
      reloadCouponsForFilters();
      triggerSearch(true);
      $(".gmc-fil-val > ul").html("");
      $("#gBody").removeClass("f-open");
      $("h2.gmc-title, .grsug, .grsug2").removeClass("go-fl-hidden");
      gaSC("clear filters");
    },
  );
}
// function AddCopyCodeFunctionality() {
//     $('.copyCode').each(function () {
//         var $this = $(this);
//         var idParam = $this.attr('id');
//         var couponCode = $this.attr('data-clipboard-text');
//         if ($("#" + idParam).length) {
//             var clipboard = new ClipboardJS("#" + idParam);
//             clipboard.on('success', function (e) {
//                 $("#" + idParam).addClass('hide');
//                 $("#" + idParam).siblings('.merchantLink').addClass('copied').removeClass('hide').show();
//             });
//             var couponid = 0;
//             couponid = $this.parents().find(".go-coupBox").attr("data-cid");
//             $.get(global.WEB_URL + 'misc/clkcpn/' + couponid + '/' + couponCode);
//         }
//     });
// }

function OpenCouponBox() {
  var pId = $("#gBody").attr("data-pagetype");
  if (pId != "2" && pId != "1") return;
  var goid = new URL(window.location.href).searchParams.get("go");
  if (!goid) return;

  // Extract numeric coupon ID for API calls (remove 'cpn_' prefix if present)
  var couponId = goid.replace(/^cpn_/, "");

  // Use the full goid (with cpn_ prefix) to find the element, but use attribute selector for numeric IDs
  var cpnBox = $(`[id="${goid}"]:not(.su)`);
  if (cpnBox.length == 0) return;

  const button = cpnBox.find(".cbtn");
  const span = $(
    `<span class="cp visible-lg copyCode" id="cpy_code_${couponId}"></span>`,
  );

  // Add highlighting class for visual emphasis
  cpnBox.addClass("go-highlighted");

  cpnBox.parent("li").prependTo($(".gmc-cl > .gmc-list").first());
  var cpnParent = cpnBox.find(".gcbr");
  var type = cpnParent.attr("data-type");

  if (type === "cp" || type == "cs" || type === "dc") {
    // Check if this is a dynamic coupon
    const isDynamicCoupon = type === "dc";
    const codeElements = cpnBox.find('span[data-type="cpn-code-text"]');

    if (isDynamicCoupon && codeElements.length > 0) {
      const currentCode = codeElements.first().text().trim();

      if (currentCode === "EXCLUSIVE" || currentCode === "" || !currentCode) {
        // Show loading state with spinner
        codeElements.html(
          'Exclusive Code <span class="loading-spinner"></span>',
        );

        request
          .get(goGlobal.WEB_URL + "api/coupon/code/" + couponId)
          .then((response) => {
            try {
              const data =
                typeof response === "string" ? JSON.parse(response) : response;
              if (data.success && data.code) {
                console.log("Dynamic code fetched successfully:", data.code);
                // Update all displayed code elements (there are multiple in the HTML)
                codeElements.text(data.code);
                // Update copy button data attribute
                span.attr("data-clipboard-text", data.code);
                // Also update data-inner-text attribute on parent elements
                cpnBox
                  .find('[data-inner-text="EXCLUSIVE"]')
                  .attr("data-inner-text", data.code);
              } else {
                console.error("Failed to fetch dynamic code:", data.message);
                codeElements.text("EXCLUSIVE");
              }
            } catch (e) {
              console.error("Error parsing dynamic code response:", e);
              codeElements.text("EXCLUSIVE");
            }
          })
          .catch((error) => {
            console.error("Error fetching dynamic code:", error);
            codeElements.text("EXCLUSIVE");
          });
      }
    }

    span.text("Copy & Visit Site");
  } else {
    button.find("span.visible-lg").text("NO CODE REQUIRED");
    // span.text('Go To ' + cpnBox.data('merchant'));
    span.text("Copy & Visit Site");
  }
  button.find("div").remove();
  button.append(span);
  button.addClass("open");
  cpnBox.removeClass("dl");

  // Smooth scroll to the highlighted coupon after DOM updates
  setTimeout(() => {
    const headerHeight = $("header").outerHeight() || 0;
    const tabHeight =
      $(
        "#gmTab.fixed, #gmTabMobile.fixed, .mobile-tabs-row.fixed",
      ).outerHeight() || 0;
    const offset = headerHeight + tabHeight + 20; // 20px extra padding
    // smoothScroll(cpnBox.offset().top - offset, 600);
  }, 100);

  // AddCopyCodeFunctionality();
}

// function MerchantLinkClick() {
//     $('#go_body').on('click', '.merchantLink', function () {
//         var $t = $(this);
//         var Cid = $t.attr('data-goid');
//         var Type = $t.data('type');
//         var rType = $t.attr('data-retype');
//         var pageType = $('body').data('pagetype');
//         var pageID = $('body').data('pageid');
//         var cType = $t.attr('data-ctype');
//         var fileName = $t.attr('data-fname');
//         var cpnPosition = $t.data('cpnpstn');
//         if (typeof (cpnPosition) === "undefined" || cpnPosition === null || cpnPosition === "") {
//             cpnPosition = 0;
//         }
//         if (typeof (pageType) === "undefined" || pageType === null || pageType === "") {
//             pageType = 0;
//         }
//         $.cookie("clickattr", pageID + "_" + pageType + "_" + Cid + "_" + cType + "_" + "{uid}" + "_" + cpnPosition, { domain: '.grabon.in', path: '/', expires: 1 });
//         $.get(global.WEB_URL + 'load/cv/' + Cid + '/' + pageID + '/' + pageType + '/' + cpnPosition, function () {
//         });

//         var win;
//         switch (Type) {
//             case "cp":
//                 type = 1;
//                 window.open(global.WEB_URL + 'load/coupon/?go=' + Cid, "_blank");
//                 break;
//             case "dl":
//                 type = 2;
//                 var loadURL = global.WEB_URL + 'load/coupon/?go=' + Cid;
//                 var pageType = $('body').data('pagetype');
//                 if (pageType === 6 || pageType === 7 || pageType === 8) {
//                     loadURL = loadURL + "&isDeal=1";
//                 }
//                 win = window.open(loadURL, "_blank");
//                 if (win) {
//                     win.focus();
//                 }
//                 break;
//             case "exp":
//                 type = 3;
//                 window.open(global.WEB_URL + 'load/coupon/?go=' + Cid, "_blank");
//                 break;
//             case "cb":
//                 type = 4;
//                 window.open($t.data('href'), "_blank");
//                 break;
//         }
//     });
// }

function share() {
  $(".gsh").on("click", function (event) {
    event.stopPropagation();
    gaSC("Coupon Share");

    const cidBox = $(this).parents(".gc-box");
    const closeShare = () => {
      $("#gShareDrop a").off("click");
      $("#gShareDrop").remove();
    };
    if (cidBox.length == 0) return;
    closeShare();

    var cid = cidBox.data("cid");
    var title = cidBox.find(".gcbr > p").text();
    const merchant = cidBox.data("merchant");
    const pagex = event.pageX - 228,
      pagey = event.pageY - 8;
    $("#gBody")
      .append(`<div class="g-share-drop" id="gShareDrop" data-coupontitle="${title}" data-merchant="${merchant}" style="top:${pagey}px;left:${pagex}px;">
            <a href="javascript:void(0)" class="sh-email">
                <span><svg xmlns="http://www.w3.org/2000/svg" width="19" height="15" viewBox="0 0 19 15"><g fill="#71A030"><path d="M.835 1.081C3.29 3.146 7.593 6.78 8.858 7.912c.17.153.352.23.541.23.19 0 .371-.076.54-.228 1.267-1.134 5.571-4.768 8.024-6.833.153-.128.176-.354.053-.51C17.73.207 17.304 0 16.847 0H1.952C1.495 0 1.069.208.783.57c-.124.157-.1.383.052.511z" /><path d="M18.77 2.148c-.14-.065-.305-.043-.422.057-2.892 2.458-6.582 5.608-7.744 6.657-.651.59-1.556.59-2.21 0C7.158 7.742 3.013 4.211.653 2.204c-.118-.1-.283-.122-.422-.057-.14.065-.23.205-.23.36v9.979c0 .875.71 1.587 1.583 1.587h15.834c.873 0 1.583-.712 1.583-1.587V2.508c0-.155-.09-.295-.23-.36z" /></g></svg></span>
                Send Via Email
            </a>
            <a href="javascript:void(0)" class="sh-twitter">
                <span><svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16">
                        <path fill="#03A9F4" d="M20 1.894c-.744.321-1.536.534-2.363.638.85-.5 1.5-1.285 1.804-2.232-.792.466-1.667.794-2.6.978C16.09.488 15.016 0 13.846 0 11.576 0 9.75 1.814 9.75 4.038c0 .32.027.628.095.92C6.435 4.796 3.419 3.187 1.393.737 1.038 1.34.83 2.032.83 2.776c0 1.399.732 2.638 1.821 3.356-.658-.013-1.305-.2-1.852-.498v.045C.8 7.64 2.221 9.27 4.085 9.646c-.334.09-.697.132-1.075.132-.262 0-.527-.014-.776-.068.531 1.598 2.038 2.774 3.831 2.812-1.395 1.074-3.166 1.722-5.084 1.722-.336 0-.658-.015-.981-.056C1.816 15.342 3.969 16 6.29 16c7.545 0 11.67-6.154 11.67-11.488 0-.178-.006-.35-.015-.522.814-.568 1.497-1.279 2.055-2.096z" /></svg></span>
                Send To Twitter
            </a>
            <a href="javascript:void(0)" class="sh-copy">
                <span><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><g fill="#3B3B3B"><path d="M11.017 6.924c-.214-.216-.451-.408-.707-.571-.678-.437-1.467-.669-2.272-.669-1.118-.002-2.19.445-2.98 1.24l-3.827 3.85C.443 11.568.001 12.642 0 13.763-.001 16.102 1.883 17.998 4.21 18c1.116.004 2.188-.44 2.976-1.234l3.16-3.176c.057-.057.09-.135.089-.216-.001-.167-.137-.302-.303-.3h-.12c-.66.001-1.315-.126-1.926-.376-.113-.047-.242-.02-.328.067L5.486 15.05c-.705.71-1.85.71-2.555 0-.705-.709-.705-1.859 0-2.568l3.843-3.859c.705-.708 1.847-.708 2.552 0 .475.45 1.216.45 1.69 0 .205-.206.33-.478.35-.768.022-.347-.105-.686-.35-.932z" /><path d="M16.767 1.24c-1.645-1.653-4.31-1.653-5.955 0L7.657 4.41c-.087.087-.112.22-.063.333.047.113.16.186.282.184h.111c.66-.001 1.312.127 1.922.378.113.047.242.02.328-.066l2.265-2.275c.705-.709 1.848-.709 2.553 0 .705.71.705 1.859 0 2.568l-2.82 2.834-.025.027-.986.986c-.705.708-1.846.708-2.55 0-.476-.45-1.216-.45-1.691 0-.206.207-.33.482-.349.774-.022.347.105.686.349.932.348.351.755.638 1.203.847.063.03.126.054.19.081.063.028.129.049.192.073.063.024.13.045.192.063l.178.049c.12.03.24.054.364.075.148.023.298.037.448.043H9.978l.18-.021c.067-.003.136-.019.214-.019h.103l.207-.03.096-.018.175-.036h.033c.739-.187 1.413-.571 1.952-1.113l3.829-3.85c1.644-1.654 1.644-4.335 0-5.989z" /></g></svg></span>
                Copy Link
            </a>
        </div>`);

    const url = goGlobal.WEB_URL + "redeem/" + cid + "/?utm_source=GrabOnShare";
    $("#gBody").one("click", ":not(#gShareDrop)", closeShare);

    $("#gShareDrop .sh-email").one("click", () => {
      gaSC("Coupon Share Click", "Email");
      const title = "Latest " + merchant + " coupon from GrabOn just for you!!";
      const subject =
        "Make the most of savings using GrabOn. Avail this coupon during checkout at " +
        merchant +
        " to get " +
        title +
        " right now!! " +
        url;
      shareEmail(url, title, subject);
      closeShare();
    });

    $("#gShareDrop .sh-twitter").one("click", () => {
      gaSC("Coupon Share Click", "Twitter");
      const text =
        "Check out this latest coupon from " + merchant + " on GrabOn:";
      shareTwitter(url, text, "GrabOn");
      closeShare();
    });

    new ClipboardJS("#gShareDrop, .sh-copy", { text: (ele) => url }).on(
      "success",
      () => {
        gaSC("Coupon Share Click", "Copy");
        closeShare;
      },
    );
  });
}

function couponSave() {
  $(".lk").on("click", async function (event) {
    event.stopPropagation();
    gaSC("Coupon Like");
    if (!isLoggedIn()) {
      openLoginModal();
      return;
    }
    const $t = $(this);
    if ($t.hasClass("liked")) return;

    const cid = $t.parents(".gc-box").attr("data-cid");
    const catType = 3;
    const data = await request.get(
      goGlobal.WEB_URL + "misc/fave/" + cid + "/" + catType,
    );
    if (!data) return;

    $t.toggleClass("liked");
    if ($t.hasClass("liked")) {
      ShowAlert("We just Saved Your Favourite");
    } else {
      ShowAlert("Removed from Favourites");
    }
  });
}

function ExtensionHandlers() {
  $(".gmcd-label").on("click", function () {
    gaSC("Extension Tabs", $(this).text().trim());
    $(".gmcd-label").removeClass("active");
    $(this).addClass("active");
    window.lazyLoad.update();
  });
}

function handleRatings() {
  var body = $("body");
  var pageid = Number(body.attr("data-pageid"));
  var pagetype = Number(body.attr("data-pagetype"));
  var countSpan = $(".go-r-count");
  var currentRating = Number(countSpan.first().text());
  let ratingNow = false;
  $("#ratingModal .star").on("click", async function () {
    gaSC("Ratings Clicked");
    if (ratingNow) return;
    ratingNow = true;

    var t = $(this);
    $("#ratingModal .star").removeClass("rategiven");
    t.addClass("rategiven");
    const rating = Math.abs(5 - t.index());

    $("#ratingSuccess").addClass("submit");
    await request.get(
      goGlobal.WEB_URL +
        "misc/saveratings/" +
        pageid +
        "/" +
        pagetype +
        "/" +
        rating +
        "/",
    );
    ShowAlert(`Your rating (${rating}) has been recorded!`);

    sessionStorage.setItem(pageid + "", rating.toString());
    countSpan.text("" + (currentRating + 1));
    $("#gmRatingRated > small").text(`Rated ${rating}/5`);
    $("#gmRating").addClass("rated");

    setTimeout(() => {
      $("#ratingSuccess").removeClass("submit");
      ratingNow = false;
    }, 2000);
  });
  var ratingDone = Number(sessionStorage.getItem(pageid + ""));
  if (ratingDone) {
    if (currentRating && !isNaN(currentRating)) {
      countSpan.text("" + (currentRating + 1));
      $("#gmRatingRated > small").text(`Rated ${ratingDone}/5`);
      $("#gmRating").addClass("rated");
    }
  }
}

function ShowUfsData() {
  var cidObject = getCidObject();
  if (cidObject && cidObject.cid.length > 0) {
    $(".go-cpn-show").each(function (ind) {
      var $t = $(this);
      var tValue = $t.attr("data-goid");
      $.each(cidObject.cid, function (ind, val) {
        if (tValue === val) {
          $t.parent().addClass("go-visited");
        }
      });
    });
  }
}

$("body").on("click", ".gmf-rel-store span", function () {
  var item = $(this);
  var parentEle = item.parent();
  let childrenEle;
  if (parentEle.hasClass("show-less")) {
    childrenEle = parentEle.children("a.hidden");
    parentEle.removeClass("show-less");
    parentEle.addClass("show-more");
    parentEle.find("span").text("Show Less");
    childrenEle.each(function () {
      var currentItem = $(this);
      currentItem.removeClass("hidden");
      currentItem.addClass("shown");
    });
  } else {
    childrenEle = parentEle.children("a.shown");
    parentEle.removeClass("show-more");
    parentEle.addClass("show-less");
    parentEle.find("span").text("Show More");
    childrenEle.each(function () {
      var currentItem = $(this);
      currentItem.removeClass("shown");
      currentItem.addClass("hidden");
    });
    // smoothscroll($('.gmf-rel-store').offset().top - ($('header').outerHeight() + $('#gmTab.fixed, #gmTabMobile.fixed').outerHeight()), 1000);
  }
});

function loadSvgs() {
  $(".gsh").html(
    `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path fill="#272B40" stroke="#272B40" stroke-width=".2" d="M51.6485176,6.9 C52.3243798,6.9 52.9372611,7.17490943 53.3811677,7.61881602 C53.8250978,8.06274614 54.1,8.67565672 54.1,9.35148241 C54.1,10.0272919 53.8251114,10.6401531 53.3812191,11.0840454 C52.9373268,11.5279377 52.3244656,11.8028263 51.6486561,11.8028263 C50.8259044,11.8028263 50.0973028,11.3948993 49.6524851,10.7710792 L49.6524851,10.7710792 L45.6842586,12.7549925 C45.7600954,12.9901456 45.8028263,13.2399612 45.8028263,13.5 C45.8028263,13.7600335 45.7599861,14.0098451 45.6842275,14.2449932 L45.6842275,14.2449932 L49.6523367,16.2289145 C50.0970383,15.6051018 50.8257679,15.1971737 51.6485176,15.1971737 C52.3243993,15.1971737 52.9372589,15.472029 53.3811325,15.9159026 C53.8250062,16.3597763 54.0998615,16.9726359 54.0998615,17.6485176 C54.0998615,18.3244068 53.8249995,18.9373087 53.3811158,19.3812185 C52.9372429,19.8251176 52.3243901,20.1 51.6485176,20.1 C50.9726554,20.1 50.3597741,19.8250906 49.9158675,19.381184 C49.4719374,18.9372539 49.1970352,18.3243433 49.1970352,17.6485176 C49.1970352,17.3886269 49.2398693,17.1389568 49.3155183,16.9039488 L49.3155183,16.9039488 L45.347359,14.9198692 C44.9025517,15.5434242 44.1740885,15.9513439 43.3513439,15.9513439 C42.6755166,15.9513439 42.0626415,15.6764756 41.6187467,15.2325808 C41.1748755,14.7887096 40.9,14.1758638 40.9,13.5 C40.9,12.8241275 41.1748824,12.2112747 41.6187815,11.7674018 C42.0626913,11.3235181 42.6755932,11.0486561 43.3514824,11.0486561 C44.1740952,11.0486561 44.902558,11.456448 45.3473673,12.080128 L45.3473673,12.080128 L49.3156011,10.0960778 C49.2397645,9.86097211 49.1970352,9.61138451 49.1970352,9.35134386 C49.1970352,8.67552573 49.4719307,8.06265743 49.9158508,7.61876348 C50.3597582,7.17488223 50.9726462,6.9 51.6485176,6.9 L51.6485176,6.9 Z M51.678643,15.9214286 C51.1941564,15.9214286 50.7548965,16.1185319 50.4367324,16.4366715 C50.1185385,16.7548408 49.9214286,17.1941028 49.9214286,17.6784998 C49.9214286,18.1629933 50.1185376,18.6022587 50.4367025,18.9204236 C50.7548898,19.2386109 51.194183,19.4357143 51.678643,19.4357143 C52.1630906,19.4357143 52.6023398,19.2386203 52.9204898,18.9204457 C53.2386325,18.6022785 53.4357143,18.1630036 53.4357143,17.6784998 C53.4357143,17.1940763 53.2386045,16.7548476 52.9204583,16.4367014 C52.6022897,16.1185328 52.1630332,15.9214286 51.678643,15.9214286 Z M43.3214286,11.7428571 C42.8369681,11.7428571 42.3977065,11.9399534 42.0795443,12.2581157 C41.761382,12.576278 41.5642857,13.0155395 41.5642857,13.5 C41.5642857,13.9844605 41.761382,14.423722 42.0795443,14.7418843 C42.3977065,15.0600466 42.8369681,15.2571429 43.3214286,15.2571429 C43.8058891,15.2571429 44.2451506,15.0600466 44.5633129,14.7418843 C44.8814751,14.423722 45.0785714,13.9844605 45.0785714,13.5 C45.0785714,13.0155395 44.8814751,12.576278 44.5633129,12.2581157 C44.2451506,11.9399534 43.8058891,11.7428571 43.3214286,11.7428571 Z M51.678643,7.56428571 C51.1941902,7.56428571 50.7549031,7.76139109 50.4367169,8.07956507 C50.1185445,8.39772526 49.9214286,8.836978 49.9214286,9.32142857 C49.9214286,9.80587914 50.1185445,10.2451319 50.4367169,10.5632921 C50.7549031,10.8814661 51.1941902,11.0785714 51.678643,11.0785714 C52.1630833,11.0785714 52.6023264,10.8814755 52.9204754,10.5633142 C53.2386257,10.2451516 53.4357143,9.8058895 53.4357143,9.32142857 C53.4357143,8.83698483 53.2386042,8.39773764 52.9204569,8.07957816 C52.6022886,7.76139761 52.1630328,7.56428571 51.678643,7.56428571 Z" transform="translate(-40 -6)" /></svg>`,
  );
  $(".lk").html(
    `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13"><path fill="#272B40" d="M19.5682574,13.0170146 C19.7781075,12.7279962 20,12.2329056 20,11.9075006 C20,10.9221935 18.9785781,10.323544 18.0675534,10.323544 L15.5926069,10.323544 C15.937263,8.84436922 15.7803524,7.54703839 15.1464279,6.72168658 C14.7938155,6.26301797 14.3285559,6 13.8694345,6 C13.4964995,6 13.1727601,6.18000071 12.9813785,6.49384992 C12.9518216,6.54237709 12.9364491,6.59747971 12.9364491,6.65382298 L12.9364491,8.3196271 C12.4787857,9.61890752 12.0350547,10.580146 11.3559129,11.2496544 C11.2302152,10.7958952 10.8088408,10.4610081 10.3086602,10.4610081 L7.08647582,10.6382439 C6.48758028,10.6382439 6,11.1176846 6,11.7073836 L6,17.7536245 C6,18.3433058 6.48758028,18.8227642 7.08647582,18.8227642 L10.3086602,19 C10.7914703,19 11.2014683,18.6882245 11.3424665,18.2584807 C11.5084313,18.3401687 11.6764122,18.3900783 11.8274547,18.3900783 L17.2832164,18.3900783 C17.5552944,18.3900783 18.0023555,18.2507178 18.2356063,17.9877353 C18.5611639,17.6205204 18.5953469,17.2305661 18.6033391,16.7669881 C19.0753489,16.4185601 19.2999595,15.9589345 19.2581083,15.0826982 C19.7652011,14.563415 19.7338082,13.4720854 19.5682574,13.0170146 Z M10.3234206,18.1132537 L7.08645782,17.936585 C6.98363881,17.936585 6.90000836,17.8545071 6.90000836,17.7536245 L6.90000836,11.7073836 C6.90000836,11.606501 6.98365681,11.5244231 7.08645782,11.5244231 L10.3234026,11.3477544 C10.3943607,11.353231 10.4542664,11.3978767 10.4806552,11.4595902 C10.3685119,11.8852044 10.1350631,12.9597675 10.1350631,14.5294743 C10.1350631,16.1887916 10.3923626,17.5469143 10.4861454,17.9868314 C10.4634467,18.0560065 10.3998329,18.107334 10.3234206,18.1132537 Z M18.8360859,12.5016306 L18.5620279,12.8790543 L18.7209365,13.315852 C18.8171854,13.5804119 18.7972948,14.2759739 18.6092973,14.4684875 L18.3408374,14.7433802 L18.3590359,15.1243309 C18.3920309,15.8153557 18.2174618,15.9442239 18.0634313,16.0579384 L17.710891,16.3181738 L17.7034027,16.7519407 C17.6960585,17.178122 17.6605255,17.2887881 17.5621346,17.4001099 C17.5157832,17.4429301 17.3581526,17.501152 17.2831804,17.5038992 L11.840001,17.5038992 C11.2683583,17.5038992 11.1477368,16.5097834 11.1131757,16.1032399 C11.0786147,15.6966963 11.0351075,15.1011308 11.0351075,14.5294743 C11.0351075,13.8543121 11.1108537,12.5798802 11.2367494,12.4744958 C12.4994503,11.6843784 13.1565236,10.3992946 13.786776,8.61001028 L13.8364755,8.46893056 L13.8364755,8.3196271 L13.8364755,6.88855411 C14.0363714,6.88855411 14.2188967,6.9834639 14.4285668,7.25621212 C14.8943845,7.8626954 14.9989315,8.90847542 14.7153692,10.1253766 L14.4627138,11.2097054 L15.5926069,11.2097054 L18.0675534,11.2097054 C18.498666,11.2097054 19.0999736,11.4751515 19.1000816,11.9023962 C19.0937995,12.0037397 18.9776241,12.3067066 18.8360859,12.5016306 Z" transform="translate(-6 -6)" /></svg>`,
  );
  if ($(".veri .dot").length) {
    // a/b test
    $(".veri .c-show-cou").prepend(
      `<svg  class="svgalign mr-1" xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14"><path fill="#7B8B8E" d="M14.5724403,0.189647059 L0.393849739,0.189647059 C0.177232382,0.189647059 0,0.366879441 0,0.583496797 L0,10.0358905 C0,10.2525079 0.177232382,10.4297403 0.393849739,10.4297403 L3.54464765,10.4297403 L3.54464765,12.7928387 C3.54464765,13.1473035 3.95818987,13.3245358 4.2141922,13.0685335 L6.89237043,10.4297403 L14.5724403,10.4297403 C14.7890577,10.4297403 14.9662901,10.2525079 14.9662901,10.0358905 L14.9662901,0.583496797 C14.9662901,0.366879441 14.7890577,0.189647059 14.5724403,0.189647059 Z M14.1785906,9.64204079 L6.73483053,9.64204079 C6.6363681,9.64204079 6.53790566,9.68142576 6.45913571,9.76019571 L4.33234712,11.8475993 L4.33234712,10.0358905 C4.33234712,9.81927317 4.15511474,9.64204079 3.93849739,9.64204079 L0.787699477,9.64204079 L0.787699477,0.977346536 L14.1785906,0.977346536 L14.1785906,9.64204079 Z"/></svg>`,
    );
    $(".veri .c-clk").prepend(
      `<svg class="svgalign mr-1" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><g fill="#7B8B8E"><path d="M12.4811046,3.96969444 C11.7957157,2.37177778 10.6310261,1.2096585 9.01976961,0.522464052 C8.21444935,0.179004902 7.3707451,0.00356862745 6.48931536,0.00356862745 C5.60803431,0.00356862745 4.77055392,0.177348039 3.96612582,0.522464052 C2.36820915,1.2078317 1.19835784,2.36920752 0.51175817,3.96969444 C0.167704248,4.77153105 0,5.6115817 0,6.49286275 C0,7.37431373 0.167704248,8.2213317 0.51175817,9.02333824 C1.19835784,10.6238252 2.36835784,11.7921683 3.96612582,12.4777059 C4.77070261,12.8228219 5.60801307,12.9964314 6.48931536,12.9964314 C7.37061765,12.9964314 8.21444935,12.8209951 9.01964216,12.4777059 C10.6308987,11.7904902 11.7955882,10.6211062 12.4811258,9.02333824 C12.8262206,8.21876144 13,7.37431373 13,6.49286275 C13,5.6115817 12.8263693,4.77425 12.4811046,3.96969444 Z M11.4434837,9.36452451 C10.9332337,10.2395817 10.2342075,10.9337859 9.35381863,11.4470523 C8.47876144,11.9573023 7.51996895,12.2146258 6.48946405,12.2146258 C5.71477451,12.2146258 4.97555882,12.0654232 4.27181699,11.759732 C3.56809641,11.4541895 2.9604951,11.0525065 2.45222059,10.5443807 C1.94394608,10.0361062 1.53939542,9.42257843 1.23689052,8.71764706 C0.935277778,8.01528595 0.789112745,7.26772222 0.789112745,6.49288399 C0.789112745,5.46223039 1.0423366,4.50830229 1.54971895,3.63566667 C2.05890686,2.75984477 2.7580817,2.06489706 3.63224673,1.55311765 C4.50626307,1.04135948 5.4588317,0.785395425 6.48931536,0.785395425 C7.51996895,0.785395425 8.4785915,1.04286765 9.35366993,1.55311765 C10.2340588,2.06640523 10.9315768,2.7613317 11.443335,3.63564542 C11.9550931,4.50981046 12.2109085,5.46223039 12.2109085,6.49286275 C12.2109085,7.52353758 11.9567712,8.48396569 11.4434837,9.36452451 Z"/><path d="M6.90159804,6.43601961 L6.90159804,2.75419444 C6.90159804,2.53387418 6.70963562,2.35616503 6.48929412,2.35616503 C6.28322712,2.35616503 6.09838072,2.53387418 6.09838072,2.75419444 L6.09838072,6.49286275 C6.09838072,6.5 6.11263399,6.52850654 6.11263399,6.54974837 C6.09838072,6.67770915 6.13402451,6.7843219 6.21924673,6.86969281 L8.34455556,8.99485294 C8.48676961,9.13706699 8.74970098,9.13706699 8.89180882,8.99485294 C9.05524346,8.83139706 9.0444951,8.59423203 8.89180882,8.44046242 L6.90159804,6.43601961 Z"/></g></svg>`,
    );
  }
}

// function onCouponClickPopup(){
//     // $('#gBody').addClass('open-coupon-modal')

//     if(Number($('#gBody').attr('data-pageid')) == 221 && Cookie.get('AllowCookies') == undefined && Cookie.get('ShowAllCoupons') != 'true'){
//         const ExpireInMins = (Minutes = 1) =>{
//             var date = new Date();
//             date.setTime(date.getTime() + (60 * Minutes * 1000));
//             return date;
//         }
//         Cookie.set('ShowAllCoupons','true',{expires:ExpireInMins(5)});
//     }

//      // if(pageID == 221){

//         //     if(thirdUrl && thirdUrl!="") {
//         //         setTimeout(()=>{
//         //             popup = window.open(thirdUrl, "_blank");
//         //             setTimeout(()=>{
//         //                 if(popup) {
//         //                     popup.close();
//         //                 }
//         //                 window.open(selfUrl, "_self");
//         //             },3000);
//         //         },1500);
//         //     }else {
//         //         let pathname = window.location.pathname;
//         //         let cModal = document.createElement('div');
//         //         cModal.classList.add('coupon-modal');
//         //         request.get(goGlobal.WEB_URL + "cid/getcouponinfo?cid=" + Cid).then((html) => {
//         //             win = window.open(blankUrl, "_self");
//         //             selfUrl = `${window.location.origin}/${pathname.split("/").join("")}?cid=${Cid}`;
//         //             cModal.innerHTML = html;
//         //             let openURL = window.open(selfUrl,"_blank");
//         //             openURL.onload = function(){
//         //                 openURL.document?.body?.classList.add('open-coupon-modal');
//         //                 openURL.document?.body?.appendChild(cModal);
//         //             }

//         //         })
//         //     }
//         // }
//         // else{
//         //     win = window.open(blankUrl, "_blank");
//         //     if(thirdUrl && thirdUrl!="") {
//         //         setTimeout(()=>{
//         //             popup = window.open(thirdUrl, "_blank");
//         //             setTimeout(()=>{
//         //                 if(popup) {
//         //                     popup.close();
//         //                 }
//         //                 window.open(selfUrl, "_self");
//         //             },3000);
//         //         },1500);
//         //     }else {
//         //         window.open(selfUrl, "_self");
//         //     }
//         // }

// }
// $('#gBody').on('click', '#closeCouponModal, #overlay', function () {
//     $('#gBody').removeClass('open-coupon-modal');
// });
// var webDomain = goGlobal.WEB_URL;
// $('#gBody').on('click','.go_c_red',function () {
//     var Cid = $(this).attr('data-cid');
//     var merchantName = $(this).attr('data-catname');
//     gaSC("Go To Merchant", merchantName);
//     window.open(webDomain + 'load/coupon/?go=' + Cid, "_blank");
// });

// $('#gBody').on('click','.go-cpn-show',onCouponClickPopup);
//     if(Boolean(Cookie.get('ShowAllCoupons')) && Number($('#gBody').attr('data-pageid')) == 221){
//         $('.cbtn>div').removeClass('visible-lg').addClass('d-none');
//         let cls = 'copy-code-span';
//         document.querySelectorAll('.go-cpn-show').forEach((ele,index)=>{
//             ele.parentElement.setAttribute('data-verified',`${ele.querySelector('.verified') != null}`);
//         })
//         /* <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
//             <path d="M17.6689 2.48309L15.5156 0.329766C15.3064 0.118512 15.0181 0 14.7193 0H8.96773C7.72496 0 6.71773 1.00758 6.71773 2.25L6.71842 11.25C6.74937 12.4945 7.75836 13.5 8.99938 13.5H15.7494C16.9869 13.5 17.9994 12.4875 17.9994 11.25V3.27832C17.9994 2.9802 17.8798 2.69402 17.6689 2.48309ZM16.3119 11.25C16.3119 11.5606 16.06 11.8125 15.7494 11.8125H8.96773C8.65702 11.8125 8.40523 11.5606 8.40523 11.25V2.25457C8.40523 1.94393 8.65709 1.69207 8.96773 1.69207H13.4677L13.4994 3.375C13.4994 3.99621 14.0032 4.5 14.6244 4.5H16.2802V11.25H16.3119ZM9.56188 15.75C9.56188 16.0606 9.31002 16.3125 8.99938 16.3125H2.21773C1.90702 16.3125 1.65523 16.0606 1.65523 15.75L1.68617 6.75352C1.68617 6.44288 1.93803 6.19102 2.24867 6.19102H5.62437V4.5H2.24902C1.00625 4.5 -0.000976562 5.50723 -0.000976562 6.75L-0.000632031 15.75C-0.000554687 16.991 1.00695 18 2.24938 18H8.99938C10.2369 18 11.2494 16.9875 11.2494 15.75V14.625H9.59352L9.56188 15.75Z" fill="#2491EF"/>
//             </svg> */
//         let html = `<button class="copy-code-span" type="submit">
//             Copy
//         </button>`;
//         $('.cbtn').append(html);
//         // $('.gc-box[data-merchant="MakeMyTrip"]').append(html);
//         // $('#gBody').on('click','.copy-code-span',(e)=>{

//         // });
//         document.querySelectorAll('.copy-code-span').forEach((ele,index)=>{
//             ele.addEventListener('click',(e)=>{
//                 // e.preventDefault();
//                 e.stopPropagation();
//                 if(ele.getAttribute('data-state') == 'clicked'){
//                     return;
//                 }
//                 document.querySelectorAll('.copy-code-span').forEach((cp,cpIndex)=>{
//                     if(index != cpIndex){
//                         cp.innerHTML = 'Copy';
//                         cp.setAttribute('data-state','closing');
//                     }
//                 })
//                 gaSC("Merchant page EXP",`"${parseInt(ele.parentElement.parentElement.parentElement.getAttribute('data-goid'))} Coupon Box"`,parseInt(ele.parentElement.parentElement.parentElement.getAttribute('data-goid')))

//                 // e.target?.setAttribute('data-state','clicked');

//                 ele.setAttribute('data-state','clicked');
//                 ele.innerHTML = 'Copied';
//                 let parent = ele.parentElement,
//                     code = parent.children[1].textContent;
//                 // $('.copy-code-span').attr('data-state','clicked');
//                 // let parent = $('.copy-code-span').parent,
//                 // code = parent.('span:nth-child(2)').innerText;

//                 parent?.setAttribute('data-coupon-copied','true');
//                 navigator.clipboard.writeText(code);
//                 $('.copied-text-exp').addClass('active');

//                 setTimeout(()=>{
//                     $('.copied-text-exp').removeClass('active');
//                     ele.innerHTML = 'Copy';
//                     ele.setAttribute('data-state','closing');
//                     parent.removeAttribute('data-coupon-copied');
//                 },1000)
//                 return;
//             },false)
//         })
//     }

const ratingV1LblSelector = "div.rating__v1 label";
const ratingV1Labels = document.querySelectorAll(ratingV1LblSelector);

ratingV1Labels.forEach((lbl, index) => {
  // const dataAnim = 'data-anim';
  // const dataCheckedAttr = 'data-checked';
  lbl.addEventListener(
    "click",
    async () => {
      // const isAnimtrue = lbl.getAttribute(dataAnim) === 'true';
      // const isChecked = lbl.getAttribute(dataCheckedAttr) === 'true';
      await ratingV1StateManagemnet("click", lbl, index);
    },
    false,
  );
});
// function ratingStarV1(){

// }

// ratingStarV1();

async function ratingV1StateManagemnet(action, lbl, index) {
  // const ratingV1LblSelector = 'div.rating__v1 label';
  // const ratingV1Labels = document.querySelectorAll(ratingV1LblSelector);
  const dataAnim = "data-anim";
  const dataCheckedAttr = "data-checked";
  $(ratingV1LblSelector).attr(dataAnim, "false");
  $(ratingV1LblSelector).attr(dataCheckedAttr, "false");
  // lbl.insertAdjacentElement('afterend', )

  await setTimeoutAsync(100);
  lbl.setAttribute(dataCheckedAttr, "true");
  ratingV1Labels.forEach(async (lbl2, index2) => {
    if (index2 <= index) {
      lbl2.setAttribute(dataAnim, "true");
    }
  });

  const ratingValue = index + 1;
  if (ratingValue !== -1 && action !== "refresh") {
    handleRatingsV2(ratingValue);
  }
}

$(".rating__v2 ul li").on("click", function () {
  ratingV2StateManagement("click", $(this));
});

function ratingV2StateManagement(action, liEle) {
  // let li = $(this),
  let li = liEle,
    ul = li.parent(),
    rating = ul.parent(),
    last = ul.find(".current");

  if (!rating.hasClass("animate-left") && !rating.hasClass("animate-right")) {
    last.removeClass("current");

    ul.children("li").each(function () {
      let current = $(this);
      current.toggleClass("active", li.index() > current.index());
    });

    rating.addClass(
      li.index() > last.index() ? "animate-right" : "animate-left",
    );
    rating.css({
      "--x": li.position().left + "px",
    });
    li.addClass("move-to");
    last.addClass("move-from");

    setTimeout(() => {
      li.addClass("current");
      li.removeClass("move-to");
      last.removeClass("move-from");
      rating.removeClass("animate-left animate-right");
    }, 800);

    const ratingValue = Array.from(ul[0].children).findIndex(
      (ele) => ele === li[0],
    );
    if (ratingValue !== -1 && action !== "refresh") {
      handleRatingsV2(ratingValue + 1);
    }
  }
}

function ExistingUserV2() {
  syncUserTypeControls(false);

  $(".existing-user-div > button, #existingUser2").on("click", function () {
    var t = $(this);
    const isActive = t.attr("data-state") === "active";
    const nextState = isActive ? "inactive" : "active";
    applyExistingUserFilter(!isActive, "Existing User");

    t.attr("data-state", nextState);
    t.attr("data-animate", "true");
    setTimeout(() => {
      t.attr("data-animate", "false");
    }, 350);
  });

  $("#allUsers2").on("click", function () {
    var t = $(this);
    applyExistingUserFilter(false, "All Users");
    t.attr("data-animate", "true");
    setTimeout(() => {
      t.attr("data-animate", "false");
    }, 350);
  });
}

async function handleRatingsV2(value) {
  var body = $("body");
  var pageid = Number(body.attr("data-pageid"));
  var pagetype = Number(body.attr("data-pagetype"));
  let ratingNow = false;
  const ratingDiv = $(".rating-div");
  const ratingAttr = "data-state-rated";

  const isClicked = ratingDiv.attr(ratingAttr) === "true";

  if (ratingNow || isClicked) return;
  ratingNow = true;
  const rating = value;
  await request.get(
    goGlobal.WEB_URL +
      "misc/saveratings/" +
      pageid +
      "/" +
      pagetype +
      "/" +
      rating +
      "/",
  );
  gaSC("Ratings Clicked");
  ShowAlert(`Your rating (${rating}) has been recorded!`);
  sessionStorage.setItem(pageid + "", rating.toString());
  setTimeout(() => {
    ratingNow = false;
  }, 2000);

  refreshRatingModule();
}

function refreshRatingModule() {
  const body = $("body");
  const pageid = Number(body.attr("data-pageid"));
  const ratingDone = Number(sessionStorage.getItem(pageid + ""));
  const countSpan = $(".rating__count__p > span");
  const currentRating = Number(countSpan.first().text());
  var ratingDiv = $(".rating-div");
  const ratingAttr = "data-state-rated";
  if (ratingDone) {
    if (currentRating && !isNaN(currentRating)) {
      countSpan.text("" + (currentRating + 1));
      ratingDiv.attr(ratingAttr, "true");

      // Version 2
      const liEle = ratingDiv.find(
        `.rating__v2 > ul li:nth-of-type(${ratingDone})`,
      );
      if (liEle && liEle !== null) {
        ratingV2StateManagement("refresh", liEle);
      }

      // Version 1
      // const labelEle = ratingDiv.find(`.rating__v1 > .rating__v1__stars > label:nth-of-type(${ratingDone})`);
      // if(labelEle && labelEle !== null){
      //     ratingV1StateManagemnet('refresh', labelEle[0], ratingDone - 1);
      // }
    }
  }
}

// Mobile Rating
(function mobileRatingModule() {
  const rateBtn = document.querySelector(".mobile-rate-btn");
  const modal = document.querySelector(".mobile-rating-modal");
  if (!rateBtn || !modal) return;

  const closeBtn = modal.querySelector(".mobile-rating-modal__close");
  const modalStarLis = modal.querySelectorAll(
    ".mobile-rating-modal__v2 > ul > li",
  );
  /** @type {HTMLElement} */
  const infoP = modal.querySelector(".mobile-rating-modal__info");
  /** @type {HTMLElement} */
  const successP = modal.querySelector(".mobile-rating-modal__success");
  const btnSpan = rateBtn.querySelector("span");
  const body = document.body;
  const pageid = Number(body.getAttribute("data-pageid"));
  const avgText = rateBtn.getAttribute("data-avg") || "";
  const votesText = rateBtn.getAttribute("data-votes") || "0";

  function renderMobileRatingLabel(userRating) {
    const baseLabel = `${avgText}/5 | ${votesText} Users`;
    if (userRating) {
      btnSpan.innerHTML = `<span class="mobile-rate-btn__meta">${baseLabel} | </span><span class="mobile-rate-btn__cta"><span class="mobile-rate-btn__cta-star">\u2605</span> <span class="mobile-rate-btn__cta-text">${userRating}/5 | You</span></span>`;
    } else {
      btnSpan.innerHTML = `<span class="mobile-rate-btn__meta">${baseLabel} | </span><span class="mobile-rate-btn__cta">Rate Now</span>`;
    }
  }

  // Check if already rated from sessionStorage
  const existingRating = sessionStorage.getItem(pageid + "");
  if (existingRating) {
    rateBtn.setAttribute("data-rated", "true");
    rateBtn.querySelector("svg path").setAttribute("fill", "#FFC242");
    rateBtn.querySelector("svg path").setAttribute("fill-opacity", "1");
    renderMobileRatingLabel(existingRating);
  } else {
    renderMobileRatingLabel(null);
  }

  // Open modal
  rateBtn.addEventListener("click", function () {
    if (rateBtn.getAttribute("data-rated") === "true") return;
    modal.setAttribute("data-state", "visible");
  });

  // Close modal
  closeBtn.addEventListener("click", function () {
    modal.setAttribute("data-state", "hidden");
  });

  // Close on overlay click
  modal.addEventListener("click", function (e) {
    if (e.target === modal) {
      modal.setAttribute("data-state", "hidden");
    }
  });

  // Star click — reuse ratingV2StateManagement for animations
  modalStarLis.forEach(function (li) {
    $(li).on("click", function () {
      const $li = $(this);
      const ratingValue = $li.index() + 1;

      // Trigger the v2 animation on the modal's rating__v2
      ratingV2StateManagement("click", $li);

      // Submit after animation
      setTimeout(function () {
        submitMobileRating(ratingValue);
      }, 850);
    });
  });

  async function submitMobileRating(rating) {
    const pagetype = Number(body.getAttribute("data-pagetype"));
    const votes = Number(rateBtn.getAttribute("data-votes")) || 0;

    try {
      await request.get(
        goGlobal.WEB_URL +
          "misc/saveratings/" +
          pageid +
          "/" +
          pagetype +
          "/" +
          rating +
          "/",
      );
      gaSC("Ratings Clicked");
      sessionStorage.setItem(pageid + "", rating.toString());

      // Update modal to success state
      infoP.style.display = "none";
      successP.style.display = "block";
      successP.textContent =
        "Your rating (" + rating + ") has been recorded successfully";

      // Update button to rated state
      rateBtn.setAttribute("data-rated", "true");
      renderMobileRatingLabel(rating);

      // Update vote count in desktop rating too
      const countSpan = document.querySelector(".rating__count__p > span");
      if (countSpan) {
        countSpan.textContent = "" + (votes + 1);
      }

      // Also mark desktop rating as rated
      const ratingDiv = document.querySelector(".rating-div");
      if (ratingDiv) {
        ratingDiv.setAttribute("data-state-rated", "true");
      }

      // Auto close after 2 seconds
      setTimeout(function () {
        modal.setAttribute("data-state", "hidden");
      }, 2000);
    } catch (e) {
      console.error("Rating failed", e);
    }
  }
})();

// Filters

let checkedCount = 0; // Declare checkedCount variable

function FilterManagementV2() {
  const filterMainDiv = $('div[data-type="filters-main-div"]');

  if (filterMainDiv && filterMainDiv.length > 0) {
    // Seatch Filter

    const searchInput = filterMainDiv.find("#mSearch");
    const filtersParentDiv = filterMainDiv.find(
      `div[data-type="filters-parent-div"]`,
    );
    const filtersChildrenDiv = filtersParentDiv.find(
      `div[data-type="filter-children-div"]`,
    );

    const dataTypeAttr = "data-type";
    const collapseAttr = "data-collapse";
    const dataCheckedAttr = "data-checked";
    const divTypeAtr = "data-div-type";
    const selectedFiltersValue = "selected-filters";

    const ariaLabelAttr = "aria-label";
    const liStyleProp = "data-filtered";

    if (searchInput && searchInput.length > 0) {
      searchInput.on("keyup", (event) => {
        const escapeCliked = event.key === "Escape";
        let searchText = event.target.value;
        if (escapeCliked) {
          searchInput.val("");
          searchText = "";
        }

        let i = 0;
        filtersChildrenDiv.each((i, ele) => {
          const firstEle = $(ele);
          const liList = firstEle.find("ul li");
          liList.each((i1, ele1) => {
            const item = $(ele1);
            const hasText = item.find("p").text().toLowerCase().trim();
            const condition = hasText.includes(searchText.toLowerCase().trim());
            item.attr(liStyleProp, `${condition}`);
            condition && i++;
          });
          firstEle.attr(collapseAttr, `${i === 0}`);
        });
      });

      searchInput.on("focus", () => {
        gaSC("Search in Filters Clicked");
      });
    }

    filtersChildrenDiv.each((i, ele) => {
      const item = $(ele);

      // Toggle of Header Div
      const headerDiv = item.find(".header-div");
      if (headerDiv && headerDiv.length > 0) {
        headerDiv.on("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const isCollapsed = item.attr(collapseAttr) === "true";
          item.attr(collapseAttr, `${!isCollapsed}`);
        });
      }

      // Checkbox Functionality
      const liList = item.find("ul li");

      liList.each((i, liele) => {
        const liEle = $(liele);
        const inputEle = liEle.find('input[type="checkbox"]');

        inputEle.on("change", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const isChecked = e.target.checked;
          var filterValue = e.target.value.toString().trim();
          var headerText = liEle
            .parent()
            .siblings(".header-div")
            ?.children("p")
            ?.text();
          console.log(headerText);
          liEle.attr(dataCheckedAttr, `${isChecked}`);
          AddOrRemoveSelectedFilters(
            inputEle.val(),
            isChecked ? "add" : "remove",
          );
          // SERVER-SIDE, not showFilteredCoupons(). The page holds 80 of up to
          // ~2,000 coupons, so hiding cards filters the window rather than the
          // list — "Home Appliances" on /electronics-coupons/ matches 259
          // coupons, and the ones already rendered are whatever landed in the
          // first 80. The International app re-fetches here for the same
          // reason. See applyServerFilters.
          reloadCouponsForFilters();
          //   smoothScroll(0, 600);
          // updateCheckedCount();
          gaSC(headerText + ` - ${isChecked ? "" : "Un"}Checked`, filterValue);
        });
      });
    });
  }
}

function updateCheckedCount() {
  const filtersParentDiv = $('div[data-type="filters-parent-div"]');
  const filtersChildrenDiv = filtersParentDiv.find(
    `div[data-type="filter-children-div"]`,
  );

  checkedCount = 0; // Reset checkedCount

  filtersChildrenDiv.each((i, ele) => {
    const liList = $(ele).find("ul li");
    liList.each((i1, ele1) => {
      const isChecked = $(ele1).find('input[type="checkbox"]').prop("checked");
      if (isChecked) {
        checkedCount++;
      }
    });
  });

  // Update checkedCount in DOM
  $(".mobile-filter-icon-v2").attr("data-state-type", "active");
  const checkCountSpan = $(".mobile-filter-icon-v2 .checkCount");
  checkCountSpan.text(String(checkedCount));
  checkedCount > 0
    ? checkCountSpan.attr("data-checked", "true")
    : checkCountSpan.removeAttr("data-checked");

  const mobileFilterIcon = $(".mobile-filter-icon-v2");
  checkedCount > 0
    ? mobileFilterIcon.attr("data-state-type", "active")
    : mobileFilterIcon.removeAttr("data-state-type");
}

function getInitialDOMOfSelectedFilter() {
  const mainDiv = document.createElement("div");
  const dataTypeAttr = "data-type";
  const divTypeAtr = "data-div-type";
  const selectedFiltersValue = "selected-filters";
  mainDiv.setAttribute(dataTypeAttr, "tags-main-div");
  mainDiv.setAttribute(divTypeAtr, selectedFiltersValue);
  mainDiv.innerHTML = '<p class="title">Filters</p>';
  const insideDivEle = document.createElement("div");
  mainDiv
    .querySelector("p.title")
    .insertAdjacentElement("afterend", insideDivEle);
  return mainDiv;
}

function getDOMOfSelectedFilter(value) {
  const butttonEle = document.createElement("button");
  const dataTypeAttr = "data-type";
  const ariaLabelAttr = "aria-label";
  const btnTypeAttr = "data-common-hover";
  butttonEle.setAttribute(ariaLabelAttr, value);
  butttonEle.setAttribute(dataTypeAttr, value);
  butttonEle.setAttribute(btnTypeAttr, "false");
  const innerHTML = `<span>${value}</span><img title="Close ${value} Filter" src="${assetUrl("close-icon-v3.svg")}" alt="Close Filter" />`;
  butttonEle.innerHTML = innerHTML;
  return butttonEle;
}

function AddOrRemoveSelectedFilters(filter, action = "add") {
  const dataTypeAttr = "data-type";
  const ariaLabelAttr = "aria-label";
  const divTypeAtr = "data-div-type";
  const mainContentEle = document.querySelector(
    `section.main-section div[${dataTypeAttr}="content-ele"]`,
  );
  const selectedFiltersValue = "selected-filters";
  let selectedFiltersMainDiv = mainContentEle.querySelector(
    `div[${divTypeAtr}=${selectedFiltersValue}]`,
  );
  const hasFilterMainDiv =
    selectedFiltersMainDiv !== undefined && selectedFiltersMainDiv !== null;
  if (!hasFilterMainDiv) {
    selectedFiltersMainDiv = getInitialDOMOfSelectedFilter();
    mainContentEle.insertBefore(
      selectedFiltersMainDiv,
      mainContentEle.firstChild,
    );
  }
  const getFilterDOM = getDOMOfSelectedFilter(filter);
  const innerDivEle = selectedFiltersMainDiv.querySelector("div");
  const filterEle = innerDivEle.querySelector(
    `button[${ariaLabelAttr}="${filter}"]`,
  );
  const hasFilterEle = filterEle !== undefined && filterEle !== null;
  const clearAllTxt = "Clear All";
  switch (action) {
    case "remove":
      filterEle?.remove();
      const allButtonEles = innerDivEle.querySelectorAll(
        `button:not([${ariaLabelAttr}="${clearAllTxt}])`,
      );
      const exceptClearAll = Array.from(allButtonEles).filter(
        (ele) => ele.getAttribute(ariaLabelAttr) !== clearAllTxt,
      );
      if (
        exceptClearAll.length == 0 ||
        allButtonEles.length == 0 ||
        filter === clearAllTxt
      ) {
        selectedFiltersMainDiv.remove();
        whenFilterActiveHideSelectors.removeClass("go-fl-hidden");
      }
      break;

    case "add":
      if (action === "add" && filter !== clearAllTxt) {
        const allButtonEles = innerDivEle.querySelectorAll("button");
        if (allButtonEles.length === 0) {
          innerDivEle.appendChild(getFilterDOM);
          const clearBtnDOM = getDOMOfSelectedFilter(clearAllTxt);
          innerDivEle.appendChild(clearBtnDOM);
        } else {
          const clearBtnEle = innerDivEle.querySelector(
            `button[${ariaLabelAttr}="${clearAllTxt}"]`,
          );
          innerDivEle.insertBefore(getFilterDOM, clearBtnEle);
        }
        whenFilterActiveHideSelectors.addClass("go-fl-hidden");
        document.body.scrollIntoView({ block: "start", behavior: "smooth" });
      }
      break;
  }
  // updateCheckedCount();
}

// Create a new instance of MutationObserver
const observer = new MutationObserver(function (mutationsList, observer) {
  for (let mutation of mutationsList) {
    if (mutation.type === "childList" || mutation.type === "attributes") {
      unCheckedSelectedFilters();
      if (mutation.type === "childList") {
        if (
          Array.from(
            $('div[data-type="desc-footer"] div[data-type="right"]'),
          ).some((ele) => ele === mutation.target)
        ) {
          onShareListClickV2();
        }
      }
      break;
    }
  }
});

// Start observing the DOM
observer.observe(
  document.querySelector(`section.main-section div[data-type="content-ele"]`),
  {
    attributes: true, // Observe changes to attributes
    childList: true, // Observe changes to the child nodes
    subtree: true, // Observe changes within the entire subtree
  },
);

function unCheckedSelectedFilterFunction(filter, isClearAll = false) {
  const filterMainDiv = $('div[data-type="filters-main-div"]');
  const dataCheckedAttr = "data-checked";
  if (filterMainDiv && filterMainDiv.length > 0) {
    const filtersParentDiv = filterMainDiv.find(
      `div[data-type="filters-parent-div"]`,
    );
    const filtersChildrenDiv = filtersParentDiv.find(
      `div[data-type="filter-children-div"]`,
    );
    if (isClearAll) {
      const allLieles = filtersChildrenDiv.find(`li`);
      allLieles.attr(dataCheckedAttr, "false");
      const allInputs = allLieles.find("input");
      allInputs.prop("checked", false);
      // AddOrRemoveSelectedFilters(filter, 'remove');
    } else {
      const inputEle = filtersChildrenDiv.find(`input[value="${filter}"]`);
      inputEle.prop("checked", false);
      inputEle.parent().attr(dataCheckedAttr, "false");
      // console.log(inputEle)
      // inputEle.trigger('change');
      // AddOrRemoveSelectedFilters(filter, 'remove');
    }
    AddOrRemoveSelectedFilters(filter, "remove");
    // RE-FETCH. Two reasons this is not optional here:
    //
    //  1. showFilteredCoupons() is the client-side path, and the list on the
    //     page is now a server-filtered result — hiding cards against an index
    //     built from the first 80 would hide rows that still match.
    //  2. The lines above clear the checkboxes with .prop("checked", false),
    //     which does NOT fire a change event, so the handler in
    //     FilterManagementV2 never runs. Removing a chip or hitting Clear All
    //     left the boxes unticked and the list still filtered.
    reloadCouponsForFilters();
  }
}

function unCheckedSelectedFilters() {
  const dataTypeAttr = "data-type";
  const divTypeAtr = "data-div-type";
  const ariaLabelAttr = "aria-label";
  const mainContentEle = document.querySelector(
    `section.main-section div[${dataTypeAttr}="content-ele"]`,
  );
  const selectedFiltersValue = "selected-filters";
  const clearAllTxt = "Clear All";
  let selectedFiltersMainDiv = mainContentEle.querySelector(
    `div[${divTypeAtr}=${selectedFiltersValue}]`,
  );
  if (selectedFiltersMainDiv) {
    const allEles = selectedFiltersMainDiv.querySelectorAll("div > button");
    allEles.forEach((item, index) => {
      const imgEle = item.querySelector("img");
      // BIND ONCE. A MutationObserver calls this on every childList/attribute
      // change, so an unguarded addEventListener stacks a new handler on the
      // same button each time. That was survivable while the handler only
      // hid DOM nodes; now it fires a fetch, so one click on a chip would
      // have sent as many requests as the observer had run.
      if (!imgEle || imgEle.getAttribute("data-bound") === "true") return;
      imgEle.setAttribute("data-bound", "true");
      imgEle.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const filter = item.getAttribute(ariaLabelAttr);
        const isClearAll = item.getAttribute(ariaLabelAttr) === clearAllTxt;
        unCheckedSelectedFilterFunction(filter, isClearAll);
      });
    });
  }
}

// Sort By Functonality

function sortByFunctions() {
  if (mainContentEle && mainContentEle !== null) {
    allTagMainEles.forEach((mainItem, mainIndex) => {
      const allTags = mainItem.querySelector("div").children;
      const mainItemType = mainItem.getAttribute(divTypeAtr);
      Array.from(allTags).forEach((tagEle, tagIndex) => {
        if (NotRequiredClick.some((ele) => ele !== mainItemType)) {
          tagEle.addEventListener("click", () => {
            const isActive = tagEle.getAttribute(stateAtr) === "active";
            const tagType =
              mainItemType === "sort-by-tags" ? "Tags" : "Country";
            const eleType = tagEle.getAttribute("data-type");
            const isAll = eleType === "all";
            if (isActive) return;
            Array.from(allTags).forEach((ele, eleIndex) => {
              ele.setAttribute(stateAtr, "inactive");
            });
            tagEle.setAttribute(stateAtr, "active");
            filterCoupon(eleType.trim(), tagType.trim().toLowerCase(), isAll);
            gaSC(`Sort By ${tagType}`, eleType.trim());
          });
        }
      });
    });
  }
}

// All Coupon Box Functionality

function couponBoxFunctionalityV2() {
  const contentEleWrapper = $(
    'section.main-section div[data-type="content-ele"]',
  );
  const allCouponBoxParent = contentEleWrapper.find(
    'div[data-type="coupon-box-parent"]',
  );
  const showmoreBtnAttr = "data-content-state";
  const showMoreDataAttr = "data-showmore-state";
  allCouponBoxParent.each((i, ele) => {
    const allEle = $(ele);
    const couponBoxParentEles = allEle.find(".gmc-list");
    couponBoxParentEles.each((cparenti, cpnparentele) => {
      const cpnParentItem = $(cpnparentele);
      const AllCpnEles = cpnParentItem.find(".gc-box");
      AllCpnEles.each((cpni, cpnele) => {
        const cpnItem = $(cpnele);
        const dataCID = cpnItem.data("cid");
        const merchant = cpnItem.data("merchant");

        // Showmore Details Click
        const cpnShowDetBtn = cpnItem.find(
          'div[data-type="right-left"] > button, div[data-type="right-left"] > div[data-type="meta-row"] > button, div[data-type="details-cta-row"] > button[data-type="details-btn"]',
        );
        if (cpnShowDetBtn) {
          cpnShowDetBtn.on("click", async function (e) {
            e.stopPropagation();
            e.preventDefault();
            const $t = $(this);
            const isOpen = $t.attr(showmoreBtnAttr) === "open";
            const value = isOpen ? "close" : "open";
            const textValue = isOpen ? "Show" : "Hide";
            $t.attr("data-animation-state", "true");
            $t.attr(showmoreBtnAttr, value);
            cpnItem.attr(showMoreDataAttr, value);
            await setTimeoutAsync(250);

            // Only update text for meta-row buttons, not for details-cta-row button
            const isCtaRowBtn = $t.attr("data-type") === "details-btn";
            if (!isCtaRowBtn) {
              $t.html(`<span data-show-hide-label>${textValue}</span> Details`);
            }

            await setTimeoutAsync(1500);
            $t.attr("data-animation-state", "false");
            gaSC("Show Details", textValue);
          });
        }

        // Share Button Click
        const shareBtn = cpnItem.find(
          'span[data-type="button"][data-content="share"]',
        );
        shareBtn.on("click", async function () {
          gaSC("Coupon Share");
          const shareItem = $(this);
          const shareUI = getShareListDOMV2(dataCID, merchant);
          const shareItemParent = shareItem.parent();
          const hasShareList = shareItemParent.has(
            'ul[data-type="v2-share-list"]',
          );
          if (hasShareList.length == 0) {
            shareItemParent.append(shareUI);
          }
          await setTimeoutAsync(10);
          shareItemParent.attr("data-share-ul-state", "open");
        });

        // Like Click

        const likeBtn = cpnItem.find(
          'span[data-type="button"][data-content="like"]',
        );
        likeBtn.on("click", async function (event) {
          event.stopPropagation();
          gaSC("Coupon Like");
          if (!isLoggedIn()) {
            openLoginModal();
            return;
          }
          const likeItem = $(this);
          const dataStateAttr = "data-state-clicked";
          const isClicked = likeItem.attr(dataStateAttr) === "true";
          if (isClicked) return;

          // POST /favorites, not .in's `misc/fave/<cid>/<catType>` — that is a
          // GrabOn.Web .NET route and does not exist on this backend. The
          // gateway takes {entityType, entityId} with the access token as a
          // Bearer, exactly as the Next.js `postFavorite` sends it.
          //
          // ENTITY ID, NOT data-cid. `data-cid` is the short show-code; the
          // gateway matches on the coupon's uuid, which the card carries as
          // data-entity-id.
          const entityId = cpnItem.attr("data-entity-id");
          const data = entityId
            ? await request.post(
                apiBase() + "/favorites",
                { entityType: "coupon", entityId },
                { bearer: Cookie.get("access_token") },
              )
            : null;
          // (message, {type}) — this repo's signature. .in's five-argument form
          // passes an image from goGlobal.IMAGE_URL, which is not a key in
          // goGlobal, so those calls render "undefinedweb-images/…" and the
          // toast shows a broken icon.
          if (!data) {
            ShowAlert("Unable to save your favourite right now. Please try again.", {
              type: "error",
            });
            return;
          }

          likeItem.attr(dataStateAttr, "true");
          ShowAlert("We just saved this coupon as your favourite.");
        });
      });
    });
  });
}

function getShareListDOMV2(cid, merchant) {
  const ulEle = document.createElement("ul");
  const dataTypeAttr = "data-type";
  const dataAttrValue = "v2-share-list";
  ulEle.setAttribute(dataTypeAttr, dataAttrValue);
  const shareList = [
    {
      name: "Share on WhatsApp",
      state: "whatsapp",
      icon: assetUrl("whatsapp-v3.svg"),
    },
    {
      name: "Share on Instagram",
      state: "instagram",
      icon: assetUrl("grabon-instagram-icon.png"),
    },
    {
      name: "Share on Facebook",
      state: "facebook",
      icon: assetUrl("facebook-v3.svg"),
    },
    {
      name: "Share on X",
      state: "twitter",
      icon: assetUrl("twitter-v3.svg"),
    },
    {
      name: "Share on LinkedIn",
      state: "linkedin",
      icon: assetUrl("linkedin-v2.svg"),
    },
    {
      name: "Close",
      state: "close",
      icon: assetUrl("close-icon-v3.svg"),
    },
  ];
  shareList.forEach((ele, index) => {
    const html = `<li data-type="v2-share-li">
            <a href="javascript:void(0)" data-merchant="${merchant}" data-cid="${cid}" data-type="${ele.state}" title="${ele.name}" aria-label="${ele.name}" role="link">
                <img src="${ele.icon}" alt="${ele.name}" width="36" height="36"/>
            </a>
        </li>`;
    ulEle.innerHTML += html;
  });
  return ulEle;
}

function onShareListClickV2() {
  const shareUL = $('ul[data-type="v2-share-list"]');
  const dataTypeAttr = "data-type";
  shareUL.each((uli, ulele) => {
    const ulEle = $(ulele);
    const shareLI = ulEle.find('li[data-type="v2-share-li"]');
    shareLI.each((lii, liele) => {
      const liEle = $(liele);
      const anchor = liEle.find("a");
      anchor.on("click", function (e) {
        e.preventDefault();
        const ele = $(this);
        const datatype = ele.attr(dataTypeAttr);
        const merchant = ele.attr("data-merchant");
        const cid = ele.attr("data-cid");
        const url =
          goGlobal.WEB_URL + "redeem/" + cid + "/?utm_source=GrabOnShare";
        if (datatype === "close") {
          ulEle.parent().attr("data-share-ul-state", "close");
        } else {
          const shareModel = new shareListV2(datatype, url, merchant);
          shareModel.callAction();
        }
      });
    });
  });
}

class shareListV2 {
  constructor(type, url, merchant) {
    this.type = type;
    this.url = url;
    this.merchant = merchant;
  }

  callAction() {
    switch (this.type) {
      case "copy":
        this.copyLink();
        break;
      case "email":
        this.emailFun();
        break;
      case "twitter":
        this.twitterFun();
        break;
      case "whatsapp":
        this.whatsappFun();
        break;
      case "facebook":
        this.facebookFun();
        break;
      case "instagram":
        this.instagramFun();
        break;
      case "linkedin":
        this.linkedinFun();
        break;
    }
  }
  copyLink() {
    new ClipboardJS('a[data-type="copy"]', { text: (ele) => this.url }).on(
      "success",
      () => {
        gaSC("Coupon Share Click", "Copy");
        // ShowAlert("Copied", "URL is copied");
      },
    );
  }

  emailFun() {
    gaSC("Coupon Share Click", "Email");
    const title =
      "Latest " + this.merchant + " coupon from GrabOn just for you!!";
    const subject =
      "Make the most of savings using GrabOn. Avail this coupon during checkout at " +
      this.merchant +
      " to get " +
      title +
      " right now!! " +
      this.url;
    shareEmail(this.url, title, subject);
  }
  twitterFun() {
    gaSC("Coupon Share Click", "Twitter");
    const text =
      "Check out this latest coupon from " + this.merchant + " on GrabOn:";
    shareTwitter(this.url, text, "GrabOn");
  }
  facebookFun() {
    gaSC("Coupon Share Click", "Facebook");
    const text =
      "Check out this latest coupon from " + this.merchant + " on GrabOn:";
    shareFacebook(this.url, text);
  }
  linkedinFun() {
    gaSC("Coupon Share Click", "LinkedIn");
    const text =
      "Check out this latest coupon from " + this.merchant + " on GrabOn:";
    shareLinkedIn(this.url, text);
  }
  instagramFun() {
    gaSC("Coupon Share Click", "Instagram");
    const text =
      "Check out this latest coupon from " + this.merchant + " on GrabOn:";
    shareInstagram(this.url, text);
  }
  whatsappFun() {
    gaSC("Coupon Share Click", "WhatsApp");
    const text =
      "Check out this latest coupon from " + this.merchant + " on GrabOn:";
    shareWhatsApp(this.url, text);
  }
}

// Extension Box

function ExtensionBoxFunV2() {
  const mainEle = $('div[data-type="gmc-det-v2"]');
  const extTabs = mainEle.find('div[data-type="ext-tabs"] > button');
  const extContentTabs = mainEle.find('div[data-type="ext-content-ele"]');

  const extShowmore = extContentTabs.find("span.mReadMore");

  extTabs.each((i, tab) => {
    const tabItem = $(tab);
    tabItem.on("click", function () {
      const isActive = tabItem.attr(stateAtr) === "active";
      const dataIDAttr = "data-id";
      gaSC("Extension Tabs", $(this).text().trim());
      if (isActive) return;
      const dataIndex = tabItem.attr("data-index");
      const contentEle = extContentTabs.filter(
        (i, ele) => $(ele).attr(dataIDAttr) === dataIndex,
      );
      if (contentEle.length) {
        extContentTabs.attr(stateAtr, "inactive");
        contentEle.attr(stateAtr, "active");

        extTabs.attr(stateAtr, "inactive");
        tabItem.attr(stateAtr, "active");
        window.lazyLoad.update();
      }
    });
  });

  // Showmore

  extShowmore.on("click", function () {
    const $t = $(this);
    const isActive = $t.parent().hasClass("show");
    const textContent = isActive ? "Read More" : "Read Less";
    !isActive ? $t.parent().addClass("show") : $t.parent().removeClass("show");
    $t.text(textContent);
  });
}

const sidebarEle = document.querySelector('div[data-type="sidebar"]');

if (sidebarEle && sidebarEle !== null) {
  const lastEle = sidebarEle.lastElementChild;
  const filterMainDiv = sidebarEle.querySelector(
    'div[data-type="filters-main-div"]',
  );
  const extBoxEle = document.querySelector('div[data-type="gmc-det-v2"]');
  const filterTabs = isMobile()
    ? document.querySelector(".mobile-tabs-row") ||
      document.querySelector("#gmTabMobile") ||
      document.querySelector("#gmTab")
    : document.querySelector("#gmTab") ||
      document.querySelector("#gmTabMobile") ||
      document.querySelector(".mobile-tabs-row");
  const headerOuterHeight = document
    .querySelector("header")
    .getBoundingClientRect().height;
  window.addEventListener("scroll", async (e) => {
    if (extBoxEle && extBoxEle !== null) {
      var extTop = extBoxEle.getBoundingClientRect().top;
    }
    if (filterMainDiv && filterMainDiv !== null) {
      var sidebarBottom = lastEle.getBoundingClientRect().bottom;
      if (sidebarBottom <= headerOuterHeight && extTop > headerOuterHeight) {
        filterMainDiv.classList.add("fixed");
      } else {
        filterMainDiv.classList.remove("fixed");
      }
    }

    if (filterTabs && filterTabs !== null) {
      const titleSection = document.querySelector("div.title-section");

      if (titleSection && titleSection !== null) {
        const titleSectionBottom = titleSection.getBoundingClientRect().bottom;
        const condition1 = titleSectionBottom < 0;
        const condition2 = extTop > headerOuterHeight;

        const sidebarOpen =
          isMobile() && sidebarEle.classList.contains("show-mobile");
        const condition = sidebarOpen
          ? false
          : isMobile()
            ? condition1
            : condition1 && condition2;
        condition
          ? filterTabs.classList.add("fixed")
          : filterTabs.classList.remove("fixed");
      }
    }
  });
}

// Bubble Hover effect

const categoryImageEle = document.querySelector(
  '.intro-section div[data-side="left"] .top-div > div[data-type="img-ele"]',
);
if (
  categoryImageEle &&
  categoryImageEle !== null &&
  $("#gBody").attr("data-pagetype") === "1"
) {
  categoryImageEle.addEventListener("mouseenter", (event) => {
    BubbleHoverEffect(categoryImageEle, event);
  });
}

// AB Testing 31/01/2023
function linkAppendForFirstCoupon() {
  const pageType = $("body").attr("data-pagetype");

  if (pageType === "2") {
    const cpnList = document.querySelectorAll(".gmc-list > .gc-box");

    const getDataMerchantName = (ele) => {
      const title = ele?.getAttribute("data-merchant");
      return title;
    };
    const filteredArr = [Array.from(cpnList)[0]];

    cpnList.forEach((ele, index) => {
      if (
        filteredArr.some(
          (filtEle) =>
            getDataMerchantName(filtEle) === getDataMerchantName(ele),
        )
      )
        return;
      filteredArr.push(ele);
    });

    filteredArr.forEach((ele, index) => {
      const anchorTag = ele.querySelector(".footer-links > a");
      if (anchorTag) {
        const anchorOnClick = anchorTag?.getAttribute("onclick");
        const pattern = /window\.open\('([^']+)'\s*,\s*'([^']+)'\);/;
        const match = anchorOnClick?.match?.(pattern);
        if (match) {
          const link = match[1];
          const target = match[2];
          anchorTag.setAttribute("href", link);
          anchorTag.removeAttribute("onclick");
          anchorTag.setAttribute("target", target);
        }
      }
    });
  }
}

// Add Or Remove Filtered Class for Parent Element

function AddOrRemoveFilterClsForParent(
  $cls,
  $type,
  $isAdding = true,
  $tagValue = "",
  dataAttribute = "",
) {
  var gBoxparent = $('div[data-type="coupon-box-parent"] > .gmc-list');
  if (!$isAdding || $type == "all") return gBoxparent.removeClass($cls);
  gBoxparent.each((i, item) => {
    const gItem = $(item);
    const allBoxs = gItem.find(`.gc-box`);
    const conditons = {
      cpn: {
        type: "data-type",
        value: "cp",
      },
      dl: {
        type: "data-type",
        value: "dl",
      },
      fresh: {
        type: "data-isfresh-cpn",
        value: "True",
      },
      tags: {
        type: "data-tags",
        value: $tagValue,
      },
      existingUser: {
        type: "data-eid",
        value: "1",
      },
    };
    let filteredBoxs = [];
    filteredBoxs = Array.from(allBoxs).filter((ele) => {
      const condType = conditons[$type]?.type;
      let condValue = conditons[$type]?.value;
      let condition = false;
      if ($type === "tags") {
        let dataValue = ele.getAttribute(`data-${dataAttribute}`);
        let tagValue = dataValue?.split(",");
        condition =
          Array.isArray(tagValue) && tagValue.indexOf(condValue) !== -1;
      } else {
        condition = ele.getAttribute(condType) === condValue;
      }
      return condition;
    });
    return filteredBoxs.length === 0
      ? gItem.addClass($cls)
      : gItem.removeClass($cls);
  });
}

function addOrRemoveAnim($elements) {
  if ($elements && $elements.length) {
    const $animCls = "g-animated";
    const $animBaseValue = "anim-init";
    const $animBaseAttr = "data-v8-type";
    $elements.each((i, ele) => {
      const $ele = $(ele);
      if (
        !$ele.hasClass($animCls) &&
        $ele.attr($animBaseAttr) == $animBaseValue
      ) {
        $ele.addClass($animCls);
      }

      const $animChilds = $ele.find(`[${$animBaseAttr}=${$animBaseValue}]`);
      if ($animChilds.length) {
        $animChilds.each((ci, ce) => {
          const $child = $(ce);
          if (!$child.hasClass($animCls)) {
            $child.addClass($animCls);
          }
        });
      }
    });
  }
}

function initPopularStoresToggle() {
  const popularStoresSections = document.querySelectorAll(
    'div[data-type="popular-stores"]',
  );
  if (!popularStoresSections || popularStoresSections.length === 0) return;

  popularStoresSections.forEach((section) => {
    const toggleBtn = section.querySelector(
      'button[data-type="popular-stores-toggle"]',
    );
    if (!toggleBtn) return;

    toggleBtn.addEventListener("click", () => {
      const defaultVisible = parseInt(
        toggleBtn.getAttribute("data-default-visible") || "6",
        10,
      );
      const shouldExpand = toggleBtn.getAttribute("data-state") !== "expanded";
      const storeItems = section.querySelectorAll("[data-store-index]");
      const hiddenClass = "go-popular-store-hidden";

      storeItems.forEach((item) => {
        const itemIndex = parseInt(
          item.getAttribute("data-store-index") || "0",
          10,
        );
        const shouldHide = !shouldExpand && itemIndex > defaultVisible;
        if (shouldHide) {
          item.classList.add(hiddenClass);
        } else {
          item.classList.remove(hiddenClass);
        }
      });

      toggleBtn.setAttribute(
        "data-state",
        shouldExpand ? "expanded" : "collapsed",
      );
      toggleBtn.setAttribute("aria-expanded", shouldExpand ? "true" : "false");
      toggleBtn.textContent = shouldExpand ? "See less" : "See more";
    });
  });
}
